/* Diamond Craft — atelier renderer.
   Draws animal-prong rings and pendants as inline SVG and powers the
   homepage configurator. No dependencies. */
(function () {
  'use strict';

  var METALS = {
    silver: { name: 'Sterling silver', stops: ['#FBFBFD', '#C9C9D2', '#8B8B96', '#E4E4E9'] },
    gold:   { name: '14k yellow gold', stops: ['#FBEEC0', '#E2BD5F', '#A67722', '#F1D78A'] },
    rose:   { name: '14k rose gold',   stops: ['#FBE1D6', '#E3A58F', '#A8634F', '#F0C4B4'] }
  };
  var STONES = {
    diamond:  { name: 'Lab diamond', a: '#FFFFFF', b: '#D6E4F3', c: '#8FB0D6', line: 'rgba(255,255,255,.55)', add: 450 },
    onyx:     { name: 'Black onyx',  a: '#4A4A52', b: '#141418', c: '#000000', line: 'rgba(255,255,255,.22)', add: 0 },
    ruby:     { name: 'Ruby',        a: '#FF8DA3', b: '#C3143A', c: '#520212', line: 'rgba(255,255,255,.4)',  add: 220 },
    emerald:  { name: 'Emerald',     a: '#9AF3CB', b: '#178A5C', c: '#053A27', line: 'rgba(255,255,255,.4)',  add: 260 },
    sapphire: { name: 'Sapphire',    a: '#9CBBFF', b: '#2244B8', c: '#0A1856', line: 'rgba(255,255,255,.4)',  add: 240 },
    quartz:   { name: 'Rose quartz', a: '#FFF0F4', b: '#F1B8C8', c: '#C58AA0', line: 'rgba(255,255,255,.5)',  add: 40 }
  };
  function ngon(n, rx, ry, rot) {
    rot = rot === undefined ? -Math.PI / 2 : rot;
    var a = [];
    for (var i = 0; i < n; i++) { var t = rot + i * 2 * Math.PI / n; a.push([Math.cos(t) * rx, Math.sin(t) * ry]); }
    return a;
  }
  function lens(w, h) {
    var a = [], n = 9, i, t;
    for (i = 0; i <= n; i++) { t = -1 + 2 * i / n; a.push([w * (1 - t * t), t * h]); }
    for (i = n - 1; i > 0; i--) { t = -1 + 2 * i / n; a.push([-w * (1 - t * t), t * h]); }
    return a;
  }
  function heart(n) {
    var a = [];
    for (var i = 0; i < n; i++) {
      var t = i * 2 * Math.PI / n;
      var x = 16 * Math.pow(Math.sin(t), 3);
      var y = -(13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t));
      a.push([x / 17 * 1.05, y / 17 + 0.08]);
    }
    return a;
  }
  var SHAPES = {
    round:    { name: 'Round',       pts: function () { return ngon(16, 1, 1); } },
    oval:     { name: 'Oval',        pts: function () { return ngon(16, .8, 1.06); } },
    marquise: { name: 'Marquise',    pts: function () { return lens(.56, 1.16); } },
    kite:     { name: 'Kite',        pts: function () { return [[0, -.95], [.84, -.05], [0, 1.15], [-.84, -.05]]; } },
    hexagon:  { name: 'Hexagon',     pts: function () { return ngon(6, 1, 1.05); } },
    emerald:  { name: 'Emerald cut', pts: function () { return [[-.58, -1.05], [.58, -1.05], [.8, -.83], [.8, .83], [.58, 1.05], [-.58, 1.05], [-.8, .83], [-.8, -.83]]; } },
    heart:    { name: 'Heart',       pts: function () { return heart(28); } }
  };
  var ANIMALS = { cat: 'Cat', doberman: 'Doberman', dachshund: 'Dachshund', labrador: 'Labrador', chihuahua: 'Chihuahua', custom: 'Your animal' };

  var uid = 0;
  function poly(a) { return a.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '); }

  function defs(id, m, s) {
    var ms = m.stops;
    return '<defs>' +
      '<linearGradient id="' + id + '-mt" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + ms[0] + '"/><stop offset=".38" stop-color="' + ms[1] + '"/><stop offset=".72" stop-color="' + ms[2] + '"/><stop offset="1" stop-color="' + ms[3] + '"/></linearGradient>' +
      '<linearGradient id="' + id + '-am" gradientUnits="userSpaceOnUse" x1="-70" y1="-150" x2="70" y2="0"><stop offset="0" stop-color="' + ms[0] + '"/><stop offset=".4" stop-color="' + ms[1] + '"/><stop offset=".78" stop-color="' + ms[2] + '"/><stop offset="1" stop-color="' + ms[3] + '"/></linearGradient>' +
      '<linearGradient id="' + id + '-bd" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + ms[3] + '"/><stop offset=".35" stop-color="' + ms[1] + '"/><stop offset=".7" stop-color="' + ms[2] + '"/><stop offset="1" stop-color="' + ms[0] + '"/></linearGradient>' +
      '<radialGradient id="' + id + '-st" cx="35%" cy="28%" r="80%"><stop offset="0" stop-color="' + s.a + '"/><stop offset=".55" stop-color="' + s.b + '"/><stop offset="1" stop-color="' + s.c + '"/></radialGradient>' +
      '<linearGradient id="' + id + '-tb" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + s.a + '"/><stop offset="1" stop-color="' + s.b + '"/></linearGradient>' +
      '<filter id="' + id + '-bl" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="8"/></filter>' +
      '</defs>';
  }

  function stoneSVG(shape, stoneKey, cx, cy, r, id, sparkle) {
    var base = (SHAPES[shape] || SHAPES.round).pts();
    var s = STONES[stoneKey] || STONES.diamond;
    var P = base.map(function (p) { return [cx + p[0] * r, cy + p[1] * r]; });
    var G = base.map(function (p) { return [cx + p[0] * r * .86, cy + p[1] * r * .86]; });
    var Q = base.map(function (p) { return [cx + p[0] * r * .52, cy + p[1] * r * .52]; });
    var o = '<g class="dc-stone">';
    o += '<polygon points="' + poly(P) + '" fill="url(#' + id + '-st)"/>';
    o += '<polygon points="' + poly(G) + '" fill="none" stroke="' + s.line + '" stroke-width=".8"/>';
    var step = P.length > 12 ? 2 : 1;
    for (var i = 0; i < P.length; i += step) {
      o += '<line x1="' + P[i][0].toFixed(1) + '" y1="' + P[i][1].toFixed(1) + '" x2="' + Q[i][0].toFixed(1) + '" y2="' + Q[i][1].toFixed(1) + '" stroke="' + s.line + '" stroke-width=".7"/>';
    }
    o += '<polygon points="' + poly(Q) + '" fill="url(#' + id + '-tb)" stroke="' + s.line + '" stroke-width=".8"/>';
    if (sparkle) {
      o += '<g class="dc-sparkle" transform="translate(' + (cx - r * .42).toFixed(1) + ',' + (cy - r * .48).toFixed(1) + ')"><path d="M0,-11 L2.2,-2.2 L11,0 L2.2,2.2 L0,11 L-2.2,2.2 L-11,0 L-2.2,-2.2 Z" fill="#fff"/></g>';
      o += '<g class="dc-sparkle two" transform="translate(' + (cx + r * .5).toFixed(1) + ',' + (cy + r * .35).toFixed(1) + ')"><path d="M0,-6 L1.3,-1.3 L6,0 L1.3,1.3 L0,6 L-1.3,1.3 L-6,0 L-1.3,-1.3 Z" fill="#fff"/></g>';
    }
    return o + '</g>';
  }

  /* Animals face +x, feet on y=0, the raised paw lands at (58,-121). */
  function animalSVG(kind, id, eye) {
    var F = 'fill="url(#' + id + '-am)"';
    var S = 'stroke="url(#' + id + '-am)" stroke-linecap="round" fill="none"';
    var E = 'fill="' + eye + '"';
    if (kind === 'custom') {
      var D = 'fill="none" stroke="#D4B483" stroke-width="1.6" stroke-dasharray="4 5" stroke-linecap="round"';
      return '<g opacity=".85">' +
        '<ellipse cx="-4" cy="-36" rx="30" ry="38" ' + D + '/><ellipse cx="16" cy="-58" rx="19" ry="30" ' + D + '/>' +
        '<circle cx="30" cy="-96" r="21" ' + D + '/><polygon points="14,-108 8,-136 28,-114" ' + D + '/><polygon points="36,-114 52,-137 46,-106" ' + D + '/>' +
        '<path d="M30,-72 L56,-118" ' + D + ' stroke-width="8"/><circle cx="58" cy="-121" r="7" ' + D + '/>' +
        '<path d="M-30,-14 C-62,-8 -66,-48 -44,-60" ' + D + ' stroke-width="5"/>' +
        '<text x="30" y="-88" text-anchor="middle" font-family="Italiana,serif" font-size="30" fill="#D4B483">?</text></g>';
    }
    var tailCat = '<path d="M-30,-14 C-62,-8 -66,-48 -44,-60" ' + S + ' stroke-width="9"/>';
    var feet = '<ellipse cx="-2" cy="-4" rx="24" ry="6" ' + F + '/><ellipse cx="38" cy="-4" rx="14" ry="5" ' + F + '/>';
    var legDown = '<path d="M20,-40 L40,-9" ' + S + ' stroke-width="12"/>';
    function paw(x0, y0) { return '<path d="M' + x0 + ',' + y0 + ' L56,-118" ' + S + ' stroke-width="13"/><circle cx="58" cy="-121" r="7.5" ' + F + '/>'; }
    switch (kind) {
      case 'doberman': return '' +
        '<path d="M-30,-22 L-46,-38" ' + S + ' stroke-width="8"/>' +
        '<ellipse cx="-4" cy="-40" rx="28" ry="42" ' + F + '/>' +
        '<ellipse cx="18" cy="-64" rx="18" ry="32" ' + F + '/>' +
        legDown + feet +
        '<polygon points="12,-112 10,-148 26,-116" ' + F + '/><polygon points="34,-118 44,-152 46,-112" ' + F + '/>' +
        '<circle cx="30" cy="-100" r="19" ' + F + '/>' +
        '<ellipse cx="46" cy="-95" rx="13" ry="7.5" transform="rotate(-8 46 -95)" ' + F + '/>' +
        paw(30, -76) +
        '<circle cx="37" cy="-104" r="2.5" ' + E + '/>';
      case 'labrador': return '' +
        '<path d="M-32,-16 C-62,-14 -68,-42 -56,-60" ' + S + ' stroke-width="11"/>' +
        '<ellipse cx="-4" cy="-38" rx="32" ry="40" ' + F + '/>' +
        '<ellipse cx="18" cy="-62" rx="21" ry="32" ' + F + '/>' +
        legDown + feet +
        '<circle cx="30" cy="-98" r="21" ' + F + '/>' +
        '<ellipse cx="14" cy="-90" rx="8" ry="17" ' + F + '/>' +
        '<ellipse cx="48" cy="-93" rx="13" ry="9" ' + F + '/>' +
        paw(30, -74) +
        '<circle cx="38" cy="-102" r="2.6" ' + E + '/>';
      case 'dachshund': return '' +
        '<path d="M-22,-12 C-52,-8 -58,-36 -46,-46" ' + S + ' stroke-width="7"/>' +
        '<ellipse cx="0" cy="-42" rx="24" ry="44" ' + F + '/>' +
        '<ellipse cx="14" cy="-70" rx="17" ry="26" ' + F + '/>' +
        '<ellipse cx="-2" cy="-4" rx="22" ry="6" ' + F + '/><ellipse cx="30" cy="-4" rx="12" ry="5" ' + F + '/>' +
        '<path d="M16,-44 L30,-10" ' + S + ' stroke-width="10"/>' +
        '<circle cx="30" cy="-98" r="17" ' + F + '/>' +
        '<ellipse cx="17" cy="-88" rx="7" ry="19" ' + F + '/>' +
        '<ellipse cx="50" cy="-94" rx="15" ry="6.5" ' + F + '/>' +
        paw(26, -78) +
        '<circle cx="36" cy="-102" r="2.4" ' + E + '/>';
      case 'chihuahua': return '' +
        '<path d="M-22,-14 C-42,-10 -44,-34 -28,-40" ' + S + ' stroke-width="6"/>' +
        '<ellipse cx="-2" cy="-30" rx="22" ry="30" ' + F + '/>' +
        '<ellipse cx="14" cy="-48" rx="14" ry="22" ' + F + '/>' +
        '<ellipse cx="-2" cy="-4" rx="18" ry="5" ' + F + '/><ellipse cx="28" cy="-4" rx="10" ry="4.5" ' + F + '/>' +
        '<path d="M14,-32 L28,-8" ' + S + ' stroke-width="9"/>' +
        '<polygon points="10,-96 -4,-136 26,-104" ' + F + '/><polygon points="36,-104 58,-138 50,-92" ' + F + '/>' +
        '<circle cx="30" cy="-84" r="20" ' + F + '/>' +
        '<ellipse cx="47" cy="-79" rx="8" ry="6" ' + F + '/>' +
        paw(24, -62) +
        '<circle cx="38" cy="-88" r="3.4" ' + E + '/>';
      default: return '' + /* cat */
        tailCat +
        '<ellipse cx="-4" cy="-36" rx="30" ry="38" ' + F + '/>' +
        '<ellipse cx="16" cy="-58" rx="19" ry="30" ' + F + '/>' +
        legDown + feet +
        '<polygon points="14,-108 8,-136 28,-114" ' + F + '/><polygon points="36,-114 52,-137 46,-106" ' + F + '/>' +
        '<circle cx="30" cy="-96" r="21" ' + F + '/>' +
        paw(30, -72) +
        '<circle cx="40" cy="-100" r="2.6" ' + E + '/>';
    }
  }

  function scene(cfg) {
    cfg = cfg || {};
    var id = 'dcg' + (uid++);
    var m = METALS[cfg.metal] || METALS.silver, s = STONES[cfg.stone] || STONES.diamond;
    var animal = ANIMALS[cfg.animal] ? cfg.animal : 'cat';
    var shape = SHAPES[cfg.shape] ? cfg.shape : 'round';
    var pendant = cfg.mode === 'pendant';
    var r = pendant ? 60 : (cfg.stoneSize || 48);
    var scx = 320, scy = pendant ? 250 : 175;
    var label = ANIMALS[animal] + ' ' + SHAPES[shape].name + ' ' + s.name + ' ' + (pendant ? 'pendant' : 'ring') + ' in ' + m.name;
    var d = '<svg viewBox="0 0 640 620" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + label + '">' + defs(id, m, s);
    if (pendant) {
      d += '<path d="M150,-10 L314,168" stroke="url(#' + id + '-mt)" stroke-width="3" fill="none"/><path d="M490,-10 L326,168" stroke="url(#' + id + '-mt)" stroke-width="3" fill="none"/>';
      d += '<rect x="310" y="158" width="20" height="30" rx="10" fill="url(#' + id + '-bd)"/>';
      d += '<ellipse cx="320" cy="385" rx="150" ry="10" fill="#000" opacity=".45" filter="url(#' + id + '-bl)"/>';
    } else {
      d += '<ellipse cx="320" cy="596" rx="190" ry="14" fill="#000" opacity=".6" filter="url(#' + id + '-bl)"/>';
      d += '<path fill-rule="evenodd" fill="url(#' + id + '-bd)" d="M105,446 a215,150 0 1 0 430,0 a215,150 0 1 0 -430,0 Z M142,446 a178,112 0 1 0 356,0 a178,112 0 1 0 -356,0 Z"/>';
      d += '<ellipse cx="320" cy="446" rx="196" ry="131" fill="none" stroke="rgba(255,255,255,.35)" stroke-width="1"/>';
      d += '<path d="M' + (scx - 22) + ',' + (scy + 30) + ' L' + (scx + 22) + ',' + (scy + 30) + ' L' + (scx + 30) + ',302 L' + (scx - 30) + ',302 Z" fill="url(#' + id + '-mt)"/>';
    }
    d += '<ellipse cx="' + scx + '" cy="' + scy + '" rx="' + (r * 1.5) + '" ry="' + (r * 1.3) + '" fill="' + s.b + '" opacity=".35" filter="url(#' + id + '-bl)"/>';
    d += stoneSVG(shape, cfg.stone, scx, scy, r, id, cfg.sparkle !== false);
    var ty = scy + 121;
    d += '<g class="dc-animal" transform="translate(' + (scx - r - 58) + ',' + ty + ')">' + animalSVG(animal, id, s.a) + '</g>';
    d += '<g class="dc-animal" transform="translate(' + (scx + r + 58) + ',' + ty + ') scale(-1,1)">' + animalSVG(animal, id, s.a) + '</g>';
    return d + '</svg>';
  }

  function animalOnly(kind, metal) {
    var id = 'dca' + (uid++); var m = METALS[metal] || METALS.gold;
    return '<svg viewBox="-80 -160 160 170" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' + defs(id, m, STONES.diamond) + animalSVG(ANIMALS[kind] ? kind : 'cat', id, '#F1DCA7') + '</svg>';
  }

  function stoneOnly(shape, stoneKey) {
    var id = 'dcs' + (uid++);
    return '<svg viewBox="0 0 100 100" aria-hidden="true">' + defs(id, METALS.silver, STONES[stoneKey] || STONES.diamond) + stoneSVG(shape, stoneKey, 50, 50, 34, id, false) + '</svg>';
  }

  function bone() {
    var id = 'dcb' + (uid++); var s = STONES.diamond; var L = s.line;
    return '<svg viewBox="0 0 200 110" aria-hidden="true">' + defs(id, METALS.gold, s) +
      '<g fill="url(#' + id + '-st)"><rect x="44" y="38" width="112" height="34" rx="6"/><circle cx="42" cy="34" r="22"/><circle cx="42" cy="76" r="22"/><circle cx="158" cy="34" r="22"/><circle cx="158" cy="76" r="22"/></g>' +
      '<g fill="none" stroke="' + L + '" stroke-width=".9"><rect x="62" y="48" width="76" height="14" rx="3"/><path d="M44,38 L62,48 M156,38 L138,48 M44,72 L62,62 M156,72 L138,62"/><path d="M30,22 L42,34 L54,22 M30,88 L42,76 L54,88 M146,22 L158,34 L170,22 M146,88 L158,76 L170,88"/><path d="M20,34 L42,34 M20,76 L42,76 M180,34 L158,34 M180,76 L158,76"/></g>' +
      '<g class="dc-sparkle" transform="translate(30,26)"><path d="M0,-8 L1.6,-1.6 L8,0 L1.6,1.6 L0,8 L-1.6,1.6 L-8,0 L-1.6,-1.6 Z" fill="#fff"/></g></svg>';
  }

  function shapeIcon(key) {
    var pts = SHAPES[key].pts().map(function (p) { return [8 + p[0] * 6.4, 8 + p[1] * 6.4]; });
    return '<svg viewBox="0 0 16 16" aria-hidden="true"><polygon points="' + poly(pts) + '" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>';
  }

  function money(n, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD', maximumFractionDigits: 0 }).format(n); }
    catch (e) { return '$' + n; }
  }

  /* ---------- configurator ---------- */
  function mountConfigurator(root) {
    if (root.dataset.dcMounted) return;
    root.dataset.dcMounted = '1';
    var ds = root.dataset;
    var state = { animal: ds.animal || 'cat', shape: ds.shape || 'round', stone: ds.stone || 'onyx', metal: ds.metal || 'silver' };
    var prices = { silver: +ds.priceSilver || 285, gold: +ds.priceGold || 1150, rose: +ds.priceRose || +ds.priceGold || 1150, eng: +ds.priceEngagement || 800 };
    var q = function (sel) { return root.querySelector(sel); };
    var stage = q('[data-dc="stage"]');
    var chips = { animal: q('[data-dc="animal"]'), shape: q('[data-dc="shape"]'), stone: q('[data-dc="stone"]'), metal: q('[data-dc="metal"]') };

    function chip(label, key, group, icon) {
      return '<button class="dc-chip" type="button" data-group="' + group + '" data-key="' + key + '" aria-pressed="' + (state[group] === key) + '">' + (icon || '') + label + '</button>';
    }
    function sw(key, group, bg, label) {
      return '<button class="dc-sw" type="button" data-group="' + group + '" data-key="' + key + '" aria-pressed="' + (state[group] === key) + '" aria-label="' + label + '" style="background:' + bg + '"><span>' + label + '</span></button>';
    }
    if (chips.animal) chips.animal.innerHTML = Object.keys(ANIMALS).map(function (k) { return chip(ANIMALS[k], k, 'animal'); }).join('');
    if (chips.shape) chips.shape.innerHTML = Object.keys(SHAPES).map(function (k) { return chip(SHAPES[k].name, k, 'shape', shapeIcon(k)); }).join('');
    if (chips.stone) chips.stone.innerHTML = Object.keys(STONES).map(function (k) { var v = STONES[k]; return sw(k, 'stone', 'radial-gradient(circle at 35% 30%, ' + v.a + ', ' + v.b + ' 55%, ' + v.c + ')', v.name); }).join('');
    if (chips.metal) chips.metal.innerHTML = Object.keys(METALS).map(function (k) { var v = METALS[k]; return sw(k, 'metal', 'linear-gradient(135deg, ' + v.stops[0] + ', ' + v.stops[1] + ' 40%, ' + v.stops[2] + ' 75%, ' + v.stops[3] + ')', v.name); }).join('');

    function render(animate) {
      if (stage) {
        stage.innerHTML = scene({ animal: state.animal, shape: state.shape, stone: state.stone, metal: state.metal, stoneSize: 54 });
        if (animate) { var a = stage.querySelectorAll('.dc-animal'); for (var i = 0; i < a.length; i++) a[i].classList.add('swap'); }
      }
      var m = METALS[state.metal], s = STONES[state.stone];
      var isEng = state.metal !== 'silver' && state.stone === 'diamond';
      var name = isEng ? (ds.engagementName || 'The Companion Setting') : (ds.productName || 'Classic Prong Ring');
      var elName = q('[data-dc="name"]'); if (elName) elName.textContent = name;
      var elLabel = q('[data-dc="stage-name"]'); if (elLabel) elLabel.textContent = name;
      var elSpec = q('[data-dc="spec"]'); if (elSpec) elSpec.innerHTML = ANIMALS[state.animal] + '<i>·</i>' + SHAPES[state.shape].name + ' ' + s.name.toLowerCase() + '<i>·</i>' + m.name;
      var elPrice = q('[data-dc="price"]');
      if (elPrice) elPrice.innerHTML = '<small>From</small>' + money(prices[state.metal] + s.add + (isEng ? prices.eng : 0), ds.currency);
      var link = q('[data-dc="request"]');
      if (link && ds.requestUrl) {
        var base = ds.requestUrl.split('?')[0].split('#')[0];
        link.href = base + '?animal=' + state.animal + '&cut=' + state.shape + '&stone=' + state.stone + '&metal=' + state.metal;
      }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-group]'); if (!b) return;
      var g = b.dataset.group; state[g] = b.dataset.key;
      var all = b.parentElement.querySelectorAll('[data-group]');
      for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-pressed', all[i] === b);
      render(g === 'animal');
    });
    render(false);
  }

  /* ---------- gold dust ---------- */
  function dust(c) {
    if (c.dataset.dcMounted) return; c.dataset.dcMounted = '1';
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { c.remove(); return; }
    var ctx = c.getContext('2d'); if (!ctx) return;
    var W, H, P = [], dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() {
      var r = c.getBoundingClientRect(); W = c.width = r.width * dpr; H = c.height = r.height * dpr;
      P = [];
      for (var i = 0; i < Math.round(W / 22); i++) P.push({ x: Math.random() * W, y: Math.random() * H, r: (Math.random() * 1.4 + .4) * dpr, v: (Math.random() * .25 + .08) * dpr, t: Math.random() * 6.28, s: Math.random() * .02 + .006 });
    }
    size(); window.addEventListener('resize', size);
    (function frame() {
      if (!c.isConnected) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) {
        var p = P[i]; p.y -= p.v; p.t += p.s; if (p.y < -10) { p.y = H + 10; p.x = Math.random() * W; }
        var a = (Math.sin(p.t) + 1) / 2 * .55 + .05;
        ctx.beginPath(); ctx.arc(p.x + Math.sin(p.t * .7) * 6, p.y, p.r, 0, 6.28);
        ctx.fillStyle = 'rgba(241,220,167,' + a + ')'; ctx.fill();
      }
      requestAnimationFrame(frame);
    })();
  }

  /* ---------- hero photo switch ---------- */
  function mountSwap(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-swap]'); if (!b || !root.contains(b)) return;
      var key = b.getAttribute('data-swap');
      var btns = root.querySelectorAll('[data-swap]');
      for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-pressed', btns[i] === b ? 'true' : 'false');
      var slides = root.querySelectorAll('[data-key]');
      for (var j = 0; j < slides.length; j++) slides[j].classList.toggle('is-on', slides[j].getAttribute('data-key') === key);
    });
  }

  /* ---------- reveal on scroll ---------- */
  var REVEAL = '.dc-hero-head, .dc-split-panel, .dc-hero-foot, .dc-head, .dc-path, .dc-card, .dc-step, .dc-realm, .dc-stone-cell, .dc-bone, .dc-sig-visual, .dc-sig-copy, .dc-portrait-wrap, .dc-artist-copy, .dc-voice, .dc-signal, .dc-custom .dc-stack, .dc-custom-art, .dc-join-in, .dc-atelier';
  var revealObserver = null;
  function mountReveal(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('dc-js');
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { entries[i].target.classList.add('is-in'); revealObserver.unobserve(entries[i].target); }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    var els = scope.querySelectorAll(REVEAL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i]; if (el.classList.contains('dc-reveal')) continue;
      el.classList.add('dc-reveal');
      // stagger siblings of the same kind
      var idx = 0, sib = el.previousElementSibling;
      while (sib && idx < 8) { if (sib.className === el.className || (sib.classList && sib.classList.contains(el.classList[0]))) idx++; sib = sib.previousElementSibling; }
      el.style.setProperty('--dc-delay', (idx * 0.07).toFixed(2) + 's');
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in'); else revealObserver.observe(el);
    }
  }

  /* ---------- sticky mobile call to action ---------- */
  function mountSticky(el){
    if (el.dataset.dcMounted) return; el.dataset.dcMounted = '1';
    function check(){ el.classList.toggle('is-on', window.scrollY > 520); }
    window.addEventListener('scroll', check, { passive: true }); check();
  }

  /* ---------- "which path fits" finder ---------- */
  function mountFinder(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var buttons = root.querySelectorAll('[data-finder-choice]');
    var results = root.querySelectorAll('[data-finder-result]');
    function choose(key) {
      for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('aria-pressed', buttons[i].getAttribute('data-finder-choice') === key ? 'true' : 'false');
      for (var j = 0; j < results.length; j++) {
        var on = results[j].getAttribute('data-finder-result') === key;
        results[j].hidden = !on;
        if (on) { results[j].classList.remove('is-in'); void results[j].offsetWidth; results[j].classList.add('is-in'); }
      }
      root.classList.add('has-choice');
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-finder-choice]'); if (!b || !root.contains(b)) return;
      choose(b.getAttribute('data-finder-choice'));
      var r = root.querySelector('[data-finder-result]:not([hidden])');
      if (r && window.matchMedia && matchMedia('(max-width: 760px)').matches) r.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  /* ---------- design session questionnaire: prefill from links, mark finished steps ---------- */
  function mountQuestionnaire(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var q = null;
    try { q = new URLSearchParams(window.location.search); } catch (e) { q = null; }
    function get(k) { return q ? (q.get(k) || '') : ''; }
    function human(h) { return String(h || '').replace(/[-_]+/g, ' ').replace(/(^|\s)(\w)/g, function (m0, sp, c) { return sp + c.toUpperCase(); }); }
    var from = get('from'), col = get('collection'), level = get('level'), animal = get('animal'), piece = get('piece');
    var fromBox = root.querySelector('[data-q-from]'), fromInput = root.querySelector('[data-q-from-input]'), fromTitle = root.querySelector('[data-q-from-title]');
    if (fromInput && (from || col)) {
      var label = from ? human(from) : human(col) + ' collection';
      fromInput.value = from ? (human(from) + ' (/products/' + from + ')') : ('Collection: ' + human(col));
      if (fromTitle) fromTitle.textContent = label;
      if (fromBox) fromBox.hidden = false;
      var clear = root.querySelector('[data-q-from-clear]');
      if (clear) clear.addEventListener('click', function () { fromInput.value = ''; if (fromBox) fromBox.hidden = true; });
    }
    var lvl = root.querySelector('[data-q-level]');
    if (lvl && level) { for (var i = 0; i < lvl.options.length; i++) { if ((lvl.options[i].getAttribute('data-level') || '') === level) { lvl.selectedIndex = i; break; } } }
    var pn = root.querySelector('[data-q-personalize]');
    function syncLevel() { if (!pn || !lvl) return; var o = lvl.options[lvl.selectedIndex]; pn.hidden = !(o && o.getAttribute('data-level') === 'personalize'); }
    if (lvl) lvl.addEventListener('change', syncLevel);
    syncLevel();
    if (animal) {
      var radios = root.querySelectorAll('[data-q-animal] input[type=radio]');
      for (var j = 0; j < radios.length; j++) { if (radios[j].value.toLowerCase().indexOf(animal.toLowerCase()) === 0) { radios[j].checked = true; break; } }
    }
    var pc = root.querySelector('[data-q-piece]');
    if (pc && piece) { for (var k = 0; k < pc.options.length; k++) { if (pc.options[k].text.toLowerCase().indexOf(piece.toLowerCase()) > -1) { pc.selectedIndex = k; break; } } }
    var ref = root.querySelector('[data-q-referrer]');
    if (ref && document.referrer) ref.value = document.referrer;
    var breed = root.querySelector('[data-q-breed]');
    root.addEventListener('change', function (e) {
      var t = e.target; if (!t || t.type !== 'radio' || !t.closest('[data-q-animal]')) return;
      if (breed && /another|other/i.test(t.value)) breed.focus();
    });
    var sets = root.querySelectorAll('.dc-q-set');
    function mark() {
      for (var m = 0; m < sets.length; m++) {
        var req = sets[m].querySelectorAll('[required]'), done = req.length > 0;
        for (var r = 0; r < req.length; r++) { if (!req[r].value || (req[r].type === 'email' && !req[r].validity.valid)) { done = false; break; } }
        if (!req.length) {
          var any = sets[m].querySelectorAll('input:not([type=hidden]),textarea');
          for (var a = 0; a < any.length; a++) { if ((any[a].type === 'radio' || any[a].type === 'checkbox') ? any[a].checked : any[a].value) { done = true; break; } }
        }
        sets[m].classList.toggle('is-done', done);
      }
    }
    root.addEventListener('input', mark); root.addEventListener('change', mark); mark();
    if ((from || col || level || animal || piece) && fromBox && !root.querySelector('.dc-q-success')) {
      var target = fromBox.hidden ? root.querySelector('.dc-q-form') : fromBox;
      if (target && target.scrollIntoView && window.matchMedia && matchMedia('(max-width: 960px)').matches) { setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250); }
    }
  }

  /* ---------- 360° viewer: lazy iframe, open/close, cleanup on section unload ---------- */
  function mountViewer360(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var mode = root.getAttribute('data-mode');
    var src = root.getAttribute('data-src') || '';
    var title = root.getAttribute('data-title') || '360 degree view';
    var open = root.querySelector('[data-v360-open]');
    var frame = root.querySelector('[data-v360-frame]');
    var poster = root.querySelector('[data-v360-poster]');
    var fallback = root.querySelector('[data-v360-fallback]');
    var close = root.querySelector('[data-v360-close]');
    if (mode !== 'embed' || !open || !frame || !/^https:\/\//.test(src)) return;
    function show() {
      if (frame.querySelector('iframe')) return;
      var f = document.createElement('iframe');
      f.src = src;
      f.title = title;
      f.setAttribute('loading', 'lazy');
      f.setAttribute('allow', 'fullscreen');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      f.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-popups allow-forms');
      frame.appendChild(f);
      frame.hidden = false;
      if (poster) poster.hidden = true;
      if (fallback) fallback.hidden = false;
      if (close) { close.hidden = false; close.focus(); }
      root.classList.add('is-open');
    }
    function hide() {
      frame.innerHTML = '';
      frame.hidden = true;
      if (poster) poster.hidden = false;
      if (fallback) fallback.hidden = true;
      if (close) close.hidden = true;
      root.classList.remove('is-open');
    }
    open.addEventListener('click', show);
    if (close) close.addEventListener('click', function () { hide(); open.focus(); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) { hide(); open.focus(); } });
    document.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.contains(root)) hide(); });
  }

  /* ---------- customize drawer: opened by [data-dc-customize] or links to #customize ---------- */
  function mountDrawer(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var panel = root.querySelector('.dc-drawer-panel');
    var closers = root.querySelectorAll('[data-drawer-close]');
    var breedField = root.querySelector('[data-drawer-breed]');
    var ref = root.querySelector('[data-q-referrer]');
    var lastTrigger = null;
    if (ref && document.referrer) ref.value = document.referrer;
    function syncBreed() {
      if (!breedField) return;
      var picked = root.querySelector('[data-q-animal] input[type=radio]:checked');
      breedField.hidden = !(picked && /dog/i.test(picked.value));
    }
    function open(trigger) {
      lastTrigger = trigger || null;
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      document.body.classList.add('dc-drawer-lock');
      var first = root.querySelector('.dc-drawer-success') || root.querySelector('input:not([type=hidden]):not([type=radio]), select, textarea');
      if (first) { if (first.tabIndex < 0 && !/input|select|textarea/i.test(first.tagName)) first.tabIndex = -1; setTimeout(function () { first.focus(); }, 260); }
    }
    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('dc-drawer-lock');
      setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 420);
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-dc-customize], a[href="#customize"], a[href$="#customize"]');
      if (!t) return;
      e.preventDefault();
      open(t);
    });
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', function () { close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
    root.addEventListener('change', function (e) { if (e.target && e.target.closest('[data-q-animal]')) syncBreed(); });
    syncBreed();
    var q = null; try { q = new URLSearchParams(window.location.search); } catch (err) { q = null; }
    var posted = root.querySelector('.dc-drawer-success');
    if (posted || (q && q.get('customize') === '1') || window.location.hash === '#customize') setTimeout(function () { open(null); }, 300);
    document.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.contains(root)) { document.body.classList.remove('dc-drawer-lock'); } });
    if (panel) panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('button, [href], input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- visual builder and quick buy: design, stone, metal, size, breed, shape; add to bag in place ---------- */
  var DCB = (function () {
    var DEF = {
      source: 'Visual builder',
      badge: '',
      step2: 'Make it yours',
      addLabel: 'Add to bag',
      buyLabel: 'Buy now',
      showBuy: true,
      delivery: 'Made to order in New York. Ships in 2 to 3 weeks.',
      perks: ['Complimentary express shipping', 'One-year warranty', '30-day exchanges on collection pieces'],
      customLabel: 'Want something different? Customize it',
      customLink: '/pages/design-your-own-ring?level=personalize',
      detailsLabel: 'Full details',
      successHeading: 'Added to your bag',
      checkoutLabel: 'Checkout',
      cartLabel: 'View bag',
      keepLabel: 'Keep shopping',
      shapePicker: true,
      shapes: 'Round, Cushion, Princess, Oval, Pear, Emerald, Marquise',
      shapeLabel: 'Diamond shape',
      shapeNote: 'Shown in round. Same price for every shape.',
      shapeProp: 'Diamond shape',
      breedTag: 'Dog Prong',
      breedMatch: 'breed',
      breeds: 'Australian Shepherd, Basset Hound, Belgian Malinois, Cane Corso, Chihuahua, Chow Chow, Dachshund, Dalmatian, Doberman (cropped ears), Doberman (natural ears), German Shepherd, Golden Retriever, Great Dane (cropped ears), Great Dane (natural ears), Labrador Retriever, Maltese, Pitbull, Pomeranian, Pug, Rottweiler, Schnauzer, Shiba Inu, Shih Tzu, Siberian Husky, Toy Poodle, Yorkie, Another breed',
      breedLabel: 'Breed',
      breedProp: 'Breed',
      breedSearch: 'Search 26 breeds',
      gemLabel: 'Gemstone shape',
      gemProp: 'Gemstone shape',
      gemNote: 'Same price for every shape.',
      gemShown: 'Photo shows [shape]',
      breedPage: '',
      breedLinkLabel: 'See every breed sculpture',
      breedPreview: true,
      breedPrevLabel: 'Your [breed] sculpture',
      breedPhotos: [],
      dragLabel: 'drag to turn',
      sizeNote: '',
      notesLabel: 'Add a note for Andrew',
      notesPlaceholder: 'A second animal, a date you need it by, anything else.',
      noteProp: 'Note',
      sizeGuideLabel: 'Size guide',
      sizeGuideLink: '',
      chooseSize: 'Choose your size',
      ringSizes: '4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, Other size',
      ringSizesSilver: '5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, Other size',
      sizeProp: 'Ring size',
      otherSize: 'Other size (we will contact you to confirm)',
      fixedMetal: 'Sterling Silver',
      diaMissing: 'Photo shows the ring without diamonds',
      chooseBreed: 'Choose a breed',
      unavailable: 'That combination is not available. Try another option.',
      addError: 'Could not add to the bag. Please try again.'
    };
    var LABEL = { metal: 'Metal', carat: 'Center diamond', length: 'Chain length', size: 'Ring size', stone: 'Stone', chip: '' };
    var ICON = {
      truck: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M2.5 6.5h10.5v9H2.5zM13 9.5h4l3 3v3h-7z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="6.5" cy="17.5" r="1.8" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="16.5" cy="17.5" r="1.8" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>',
      paw: '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><ellipse cx="12" cy="16" rx="5" ry="4" fill="currentColor"/><circle cx="5.8" cy="10.2" r="2" fill="currentColor"/><circle cx="9.4" cy="6.4" r="2" fill="currentColor"/><circle cx="14.6" cy="6.4" r="2" fill="currentColor"/><circle cx="18.2" cy="10.2" r="2" fill="currentColor"/></svg>',
      check: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      shield: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M8.8 12.2l2.2 2.2 4.2-4.4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      swap: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 8h13l-3-3M20 16H7l3 3" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      card: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><rect x="3" y="6" width="18" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M3 10h18M7 14.5h4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
      lock: '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
      turn: '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M4 12a8 4 0 0 0 16 0" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M17.4 14.7l2.7-2.5-3.5-1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      cal: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M3.5 9.5h17M8 3v4M16 3v4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>'
    };
    var SHAPES = {
      round: '<circle cx="20" cy="20" r="15"/><path d="M20 5l6 9-6 6-6-6zM20 35l6-9-6-6-6 6zM5 20l9-6M35 20l-9-6M5 20l9 6M35 20l-9 6" fill="none" opacity=".45"/>',
      cushion: '<rect x="5.5" y="5.5" width="29" height="29" rx="9"/><path d="M12.5 12.5h15v15h-15zM5.5 20h7M27.5 20h7M20 5.5v7M20 27.5v7" fill="none" opacity=".45"/>',
      princess: '<rect x="6" y="6" width="28" height="28"/><path d="M6 6l28 28M34 6L6 34M13 13h14v14H13z" fill="none" opacity=".45"/>',
      oval: '<ellipse cx="20" cy="20" rx="11" ry="15.5"/><ellipse cx="20" cy="20" rx="5.5" ry="8.5" fill="none" opacity=".45"/>',
      pear: '<path d="M20 4c7 8 12 14 12 21a12 12 0 0 1-24 0C8 18 13 12 20 4z"/><path d="M20 13l5 12-5 6-5-6z" fill="none" opacity=".45"/>',
      emerald: '<path d="M12 5h16l5 5v20l-5 5H12l-5-5V10z"/><path d="M14 10h12v20H14z" fill="none" opacity=".45"/>',
      marquise: '<path d="M20 3c9 7 11 13 11 17s-2 10-11 17C11 30 9 24 9 20s2-10 11-17z"/><path d="M20 10v20M14 20h12" fill="none" opacity=".45"/>',
      asscher: '<path d="M13 6h14l7 7v14l-7 7H13l-7-7V13z"/><path d="M15 12h10l3 3v10l-3 3H15l-3-3V15z" fill="none" opacity=".45"/>',
      radiant: '<path d="M11 5h18l5 5v20l-5 5H11l-5-5V10z"/><path d="M11 5l9 15 9-15M11 35l9-15 9 15" fill="none" opacity=".45"/>',
      heart: '<path d="M20 34S6 25 6 15a7 7 0 0 1 14-2 7 7 0 0 1 14 2c0 10-14 19-14 19z"/>'
    };

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function handle(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function list(s) { return (Array.isArray(s) ? s : String(s || '').split(',')).map(function (x) { return String(x || '').trim(); }).filter(Boolean); }
    function base() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
    function money(c) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var v = (c || 0) / 100;
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
      catch (e) { return '$' + v.toFixed(v % 1 ? 2 : 0); }
    }
    function perkIcon(x) {
      var t = String(x).toLowerCase();
      if (/ship|deliver/.test(t)) return ICON.truck;
      if (/warrant|guarant/.test(t)) return ICON.shield;
      if (/exchange|return/.test(t)) return ICON.swap;
      if (/shop pay|install|pay over/.test(t)) return ICON.card;
      return ICON.check;
    }
    function shipBy(c) {
      if (!c.deliveryDynamic) return c.delivery || '';
      var a = new Date(), b = new Date(), fmt = function (d) { try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); } };
      a.setDate(a.getDate() + (+c.deliveryMin || 14)); b.setDate(b.getDate() + (+c.deliveryMax || 21));
      return String(c.deliveryFormat || 'Made to order. Ships between [from] and [to].').replace('[from]', fmt(a)).replace('[to]', fmt(b));
    }
    function thumb(u) { return String(u).replace(/width=\d+/, 'width=200'); }
    function pretty(v) { return String(v).split(' (')[0]; }
    function short(v, kind) {
      if (kind === 'size' && /^other/i.test(v)) return 'Not sure';
      if (kind === 'length') return String(v).replace(/\s*inch(es)?/i, '"');
      if (kind === 'metal') return pretty(v).replace(/14kt/i, '14k');
      return pretty(v);
    }
    function cfgFrom(scope) {
      var c = {}, k, o;
      for (k in DEF) c[k] = DEF[k];
      var g = document.querySelector('script[data-dc-global]');
      if (g) { if (!g._dc) g._dc = parse(g.textContent); o = g._dc; for (k in o) if (o[k] !== null && o[k] !== '' && o[k] !== undefined) c[k] = o[k]; }
      var el = scope && scope.querySelector && scope.querySelector('script[data-dc-build-config]');
      if (el) { o = parse(el.textContent); for (k in o) if (o[k] !== null && o[k] !== '' && o[k] !== undefined) c[k] = o[k]; }
      c.perks = list(c.perks); if (c.perk4) c.perks.push(c.perk4);
      return c;
    }
    function product(h) {
      if (!h) return null;
      var els = document.querySelectorAll('script[data-dc-product]'), i;
      for (i = 0; i < els.length; i++) {
        if (els[i].getAttribute('data-dc-product') !== h) continue;
        if (!els[i]._dc) els[i]._dc = parse(els[i].textContent);
        if (els[i]._dc && els[i]._dc.variants) return els[i]._dc;
      }
      return null;
    }
    function values(p, i) { var out = []; p.variants.forEach(function (v) { var x = v.o[i]; if (x != null && out.indexOf(x) < 0) out.push(x); }); return out; }
    function kindOf(name, vals) {
      var n = String(name).toLowerCase();
      if (/metal/.test(n)) return 'metal';
      if (/diamond size|carat/.test(n) || (vals.length && vals.every(function (v) { return /\bct\b|carat/i.test(v); }))) return 'carat';
      if (/length/.test(n)) return 'length';
      if (/size|finger/.test(n)) return 'size';
      if (/accent|halo|^diamonds?$|with diamonds/.test(n)) return 'accent';
      if (/stone|gem|baguette|kite|\dmm/.test(n)) return 'stone';
      return 'chip';
    }
    function shapeKey(s) {
      var k = handle(s), keys = ['cushion', 'oval', 'pear', 'princess', 'emerald', 'marquise', 'asscher', 'radiant', 'heart'], i;
      for (i = 0; i < keys.length; i++) if (k.indexOf(keys[i]) > -1) return keys[i];
      return /square/.test(k) ? 'princess' : 'round';
    }
    function sized(u, w) { u = String(u || ''); if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 1200); }
    var LISTINGS = {};
    function listing(h, cb) {
      var x = LISTINGS[h];
      if (x && (x.data || x.failed)) { cb(x.data); return; }
      if (x) { x.cbs.push(cb); return; }
      x = LISTINGS[h] = { data: null, failed: false, cbs: [cb] };
      fetch(base() + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { x.data = d; x.cbs.splice(0).forEach(function (fn) { fn(d); }); })
        .catch(function () { x.failed = true; x.cbs.splice(0).forEach(function (fn) { fn(null); }); });
    }
    var PHOTOS = null;
    function photoMap() {
      if (PHOTOS) return PHOTOS;
      PHOTOS = {};
      var g = document.querySelector('script[data-dc-global]'), o = g ? (g._dc || (g._dc = parse(g.textContent))) : {};
      (o.breedPhotos || []).forEach(function (r) { if (r && r[0] && r[1]) { var xy = String(r[2] || '50 40').split(/\s+/); PHOTOS[handle(r[0])] = { u: r[1], x: +xy[0] || 50, y: +xy[1] || 40 }; } });
      return PHOTOS;
    }
    var BREEDS = {};
    function breedPhoto(page, name, cb) {
      var known = photoMap()[handle(name)]; if (known) { cb(known.u); return; }
      page = String(page || '').split('#')[0];
      var want = handle(name), done = function (map) { cb(map[want] || ''); };
      if (!page || !want) { cb(''); return; }
      var x = BREEDS[page];
      if (x && x.map) { done(x.map); return; }
      if (x) { x.cbs.push(done); return; }
      x = BREEDS[page] = { map: null, cbs: [done] };
      fetch(page, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var map = {}, doc = new DOMParser().parseFromString(html, 'text/html'), els = doc.querySelectorAll('[data-dc-breed-card]'), i, u;
          for (i = 0; i < els.length; i++) { u = els[i].getAttribute('data-dc-breed-img'); if (u) map[els[i].getAttribute('data-dc-breed-card')] = u; }
          x.map = map; x.cbs.splice(0).forEach(function (fn) { fn(map); });
        })
        .catch(function () { x.map = {}; x.cbs.splice(0).forEach(function (fn) { fn({}); }); });
    }
    function cartCount() {
      fetch(base() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = cart.item_count, els = document.querySelectorAll('[data-dc-cart-count]'), i;
          for (i = 0; i < els.length; i++) { els[i].textContent = n; els[i].hidden = !n; }
          var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
          if (bubble) {
            var a = bubble.querySelector('[aria-hidden]'), vh = bubble.querySelector('.visually-hidden');
            if (a) a.textContent = n < 100 ? n : '';
            if (vh) vh.textContent = n;
          }
          var icon = document.getElementById('cart-icon-bubble');
          if (icon && n > 0) icon.classList.remove('header__cart--empty');
        })
        .catch(function () {});
    }

    function Stage(el, p, c, opts) {
      var self = this;
      this.el = el; this.p = p; this.c = c; this.opts = opts || {};
      var moved = el.querySelectorAll('form[data-dc-pt]');
      for (var mi = 0; mi < moved.length; mi++) if (moved[mi]._dcHome) moved[mi]._dcHome.appendChild(moved[mi]);
      this.vals = p.options.map(function (n, i) { return values(p, i); });
      this.kinds = p.options.map(function (n, i) { return kindOf(n, self.vals[i]); });
      var t = String(p.title || '').toLowerCase();
      this.dog = !!((c.breedTag && (p.tags || []).indexOf(c.breedTag) > -1) || (c.breedMatch && t.indexOf(String(c.breedMatch).toLowerCase()) > -1));
      this.shape = (c.shapePicker && this.kinds.indexOf('carat') > -1 && !p.options.some(function (n) { return /shape/i.test(n); })) ? (list(c.shapes)[0] || '') : '';
      this.breed = ''; this.note = ''; this.img = 0; this.query = '';
      this.gems = list(p.shapes); this.gemLinks = Array.isArray(p.shapeLinks) ? p.shapeLinks : [];
      this.gem = this.gems[0] || ''; this.shown = this.gem; this.altOn = false; this.gemKey = null;
      if (this.gems.length > 1) this.shape = '';
      // a ring whose size is not a variant option (it moved off the variants to make room for Diamonds): ask here, save it on the order line
      var ringT = String(p.title || '');
      this.psizes = (/\bring\b/i.test(ringT) && !/pendant|necklace/i.test(ringT) && this.kinds.indexOf('size') < 0 && this.kinds.indexOf('length') < 0) ? list(this.kinds.indexOf('carat') > -1 ? c.ringSizes : c.ringSizesSilver) : [];
      this.psize = '';
      this.dia = (p.dia && Array.isArray(p.dia.s) && p.dia.s.length) ? p.dia : null;
      this.pv = Array.isArray(p.videos) ? p.videos : []; this.xv = Array.isArray(p.xv) ? p.xv : [];
      this.vids = []; this.vidOn = -1; this.vidKey = null; this._autoVid = false;
      var first = p.variants.filter(function (v) { return v.a; })[0] || p.variants[0];
      this.sel = p.options.map(function (n, i) {
        var vals = self.vals[i];
        if (vals.length === 1) return vals[0];
        if (self.kinds[i] === 'size') return null;
        if (self.kinds[i] === 'length') { var l = vals.filter(function (v) { return /18/.test(v); })[0]; return l || vals[vals.length - 1]; }
        return first ? first.o[i] : null;
      });
      var v3 = c.v360; if (Array.isArray(v3)) v3 = v3.filter(function (x) { return x && x.handle === p.handle; })[0] || null;
      this.v360 = (v3 && v3.handle && v3.handle === p.handle && (v3.hd || v3.sd)) ? v3 : null;
      this.show360 = !!this.v360;
      if (this.v360 && v3.stone) {
        var si = this.kinds.indexOf('stone');
        if (si > -1) { var hs = handle(v3.stone), hit = this.vals[si].filter(function (v) { return handle(v) === hs; })[0] || this.vals[si].filter(function (v) { return handle(v).indexOf(hs) === 0; })[0]; if (hit) this.sel[si] = hit; }
      }
      el._dcStage = this;
      this.render();
    }
    Stage.prototype.match = function (ignore) {
      var sel = this.sel;
      return this.p.variants.filter(function (v) {
        for (var i = 0; i < sel.length; i++) { if (i === ignore) continue; if (sel[i] != null && v.o[i] !== sel[i]) return false; }
        return true;
      });
    };
    Stage.prototype.variant = function () {
      for (var i = 0; i < this.sel.length; i++) if (this.sel[i] == null) return null;
      return this.match(-1)[0] || null;
    };
    Stage.prototype.imageIndex = function () {
      var m = this.match(-1), n = this.p.images.length;
      for (var k = 0; k < m.length; k++) if (m[k].m > 0 && m[k].m <= n) return m[k].m - 1;
      return null;
    };
    Stage.prototype.swatch = function (k, v) {
      if (k === 'metal') return '<span class="dc-metal-dot" data-metal="' + handle(v) + '"></span>';
      if (k === 'stone') return '<span class="dc-gem-dot" data-gem="' + handle(v) + '"></span>';
      if (k === 'carat') return '<span class="dc-gem-dot" data-gem="lab-diamond"></span>';
      return '';
    };
    Stage.prototype.optButton = function (i, k, v) {
      var sw = (k === 'stone' || k === 'metal');
      var cls = 'dc-b-opt ' + (sw ? 'dc-b-sw' : 'dc-b-chip') + ((k === 'size' || k === 'length') ? ' dc-b-size' : '');
      var dl = (k === 'carat' || k === 'accent' || k === 'metal') ? '<small data-b-delta></small>' : '';
      var inner = sw ? this.swatch(k, v) + '<span class="dc-b-swl">' + esc(short(v, k)) + '</span>' + dl : (k === 'carat' ? this.swatch(k, v) : '') + '<span>' + esc(short(v, k)) + '</span>' + dl;
      return '<button type="button" class="' + cls + '" data-b-opt="' + i + '" data-b-val="' + esc(v) + '" aria-pressed="false" title="' + esc(v) + '">' + inner + '</button>';
    };
    Stage.prototype.groupHTML = function (i) {
      var self = this, c = this.c, k = this.kinds[i], vals = this.vals[i];
      var label = LABEL[k] || this.p.options[i];
      if (vals.length === 1) return '<div class="dc-b-group dc-b-fixedgroup dc-b-g-' + k + '" data-b-group="' + i + '"><div class="dc-b-gh"><span class="dc-b-gl">' + esc(label) + '</span>' + this.swatch(k, vals[0]) + '<span class="dc-b-gv">' + esc(short(vals[0], k)) + '</span></div></div>';
      var h = '<div class="dc-b-group dc-b-g-' + k + '" data-b-group="' + i + '"><div class="dc-b-gh"><span class="dc-b-gl">' + esc(label) + '</span><span class="dc-b-gv" data-b-gv="' + i + '"></span>';
      if (k === 'size' && c.sizeGuideLink) h += '<a class="dc-b-guide" href="' + esc(c.sizeGuideLink) + '" target="_blank" rel="noopener">' + esc(c.sizeGuideLabel) + '</a>';
      h += '</div>';
      h += '<div class="dc-b-opts" role="group" aria-label="' + esc(label) + '">';
      vals.forEach(function (v) { h += self.optButton(i, k, v); });
      h += '</div>';
      if (k === 'size' && c.sizeNote) h += '<p class="dc-b-hint">' + esc(c.sizeNote) + '</p>';
      return h + '</div>';
    };
    Stage.prototype.psizeHTML = function () {
      var c = this.c, h = '<div class="dc-b-group dc-b-g-size" data-b-group="psize"><div class="dc-b-gh"><span class="dc-b-gl">' + esc(LABEL.size) + '</span><span class="dc-b-gv" data-b-gv="psize"></span>';
      if (c.sizeGuideLink) h += '<a class="dc-b-guide" href="' + esc(c.sizeGuideLink) + '" target="_blank" rel="noopener">' + esc(c.sizeGuideLabel) + '</a>';
      h += '</div><div class="dc-b-opts" role="group" aria-label="' + esc(LABEL.size) + '">';
      this.psizes.forEach(function (v) { h += '<button type="button" class="dc-b-opt dc-b-chip dc-b-size" data-b-psize="' + esc(v) + '" aria-pressed="false" title="' + esc(v) + '"><span>' + esc(short(v, 'size')) + '</span></button>'; });
      h += '</div>';
      if (c.sizeNote) h += '<p class="dc-b-hint">' + esc(c.sizeNote) + '</p>';
      return h + '</div>';
    };
    var breedUid = 0, noteUid = 0;
    Stage.prototype.breedHTML = function () {
      var c = this.c, b = list(c.breeds), id = 'dc-b-breed-' + (++breedUid), ph = photoMap(), withPhotos = b.filter(function (x) { return ph[handle(x)]; }).length;
      if (withPhotos >= 6) {
        var r = '<div class="dc-b-group dc-b-g-breed" data-b-group="breed"><div class="dc-b-gh"><span class="dc-b-gl">' + esc(c.breedLabel) + '</span><span class="dc-b-gv" data-b-gv="breed"></span>' + (c.breedPage ? '<a class="dc-b-guide" href="' + esc(c.breedPage) + '" target="_blank" rel="noopener" data-b-breedlink>' + esc(c.breedLinkLabel) + '</a>' : '') + '</div>';
        r += '<label class="dc-b-bsearch"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/></svg><input type="search" data-b-search placeholder="' + esc(c.breedSearch || 'Search breeds') + '" aria-label="' + esc(c.breedSearch || 'Search breeds') + '" autocomplete="off" enterkeyhint="search"></label>';
        r += '<div class="dc-b-rosterwrap"><button type="button" class="dc-b-rnav prev" data-b-rnav="-1" aria-label="Earlier breeds">&#8249;</button><div class="dc-b-roster" role="group" aria-label="' + esc(c.breedLabel) + '">';
        var anyB = b.filter(function (x) { return /another/i.test(x); }), rest = b.filter(function (x) { return !/another/i.test(x); });
        b = rest.filter(function (x) { return ph[handle(x)]; }).concat(rest.filter(function (x) { return !ph[handle(x)]; }), anyB);
        b.forEach(function (x) {
          var p = ph[handle(x)];
          r += '<button type="button" class="dc-b-av" data-b-breed="' + esc(x) + '" aria-pressed="false"><span class="dc-b-av-img">' + (p ? '<img src="' + esc(p.u) + '" alt="" loading="lazy" style="--fx:' + p.x + '%;--fy:' + p.y + '%">' : ICON.paw) + '</span><span class="dc-b-av-name">' + esc(x) + '</span></button>';
        });
        return r + '</div><button type="button" class="dc-b-rnav next" data-b-rnav="1" aria-label="More breeds">&#8250;</button></div><p class="dc-b-hint dc-b-nomatch" data-b-nomatch hidden>No breed by that name yet. Choose Another breed and tell Andrew in the note.</p></div>';
      }
      var h = '<div class="dc-b-group dc-b-g-breed" data-b-group="breed"><div class="dc-b-gh"><label class="dc-b-gl" for="' + id + '">' + esc(c.breedLabel) + '</label></div>';
      h += '<div class="dc-b-selwrap"><select class="dc-b-select" id="' + id + '" data-b-breedsel><option value="">' + esc(c.chooseBreed) + '</option>';
      b.forEach(function (x) { h += '<option value="' + esc(x) + '">' + esc(x) + '</option>'; });
      h += '</select></div>';
      if (c.breedPage) h += '<div class="dc-b-breedmore"><figure class="dc-b-breedprev" data-b-breedprev hidden><img alt="" data-b-breedimg><figcaption data-b-breedcap></figcaption></figure><a class="dc-b-breedlink" href="' + esc(c.breedPage) + '" target="_blank" rel="noopener" data-b-breedlink>' + ICON.paw + '<span>' + esc(c.breedLinkLabel) + '</span></a></div>';
      return h + '</div>';
    };
    Stage.prototype.shapeHTML = function () {
      var c = this.c, self = this;
      var h = '<div class="dc-b-group dc-b-g-shape" data-b-group="shape"><div class="dc-b-gh"><span class="dc-b-gl">' + esc(c.shapeLabel) + '</span><span class="dc-b-gv" data-b-gv="shape"></span></div><div class="dc-b-opts" role="group" aria-label="' + esc(c.shapeLabel) + '">';
      list(c.shapes).forEach(function (s) {
        h += '<button type="button" class="dc-b-opt dc-b-shapebtn" data-b-shape="' + esc(s) + '" aria-pressed="' + (self.shape === s) + '"><svg viewBox="0 0 40 40" aria-hidden="true">' + (SHAPES[handle(s)] || SHAPES.round) + '</svg><span>' + esc(s) + '</span></button>';
      });
      return h + '</div>' + (c.shapeNote ? '<p class="dc-b-hint">' + esc(c.shapeNote) + '</p>' : '') + '</div>';
    };
    Stage.prototype.gemHTML = function () {
      var c = this.c, self = this;
      var h = '<div class="dc-b-group dc-b-g-shape dc-b-g-gem" data-b-group="gem"><div class="dc-b-gh"><span class="dc-b-gl">' + esc(c.gemLabel) + '</span><span class="dc-b-gv" data-b-gv="gem"></span></div><div class="dc-b-opts" role="group" aria-label="' + esc(c.gemLabel) + '">';
      this.gems.forEach(function (g) {
        h += '<button type="button" class="dc-b-opt dc-b-shapebtn" data-b-gem="' + esc(g) + '" aria-pressed="' + (self.gem === g) + '"><svg viewBox="0 0 40 40" aria-hidden="true">' + SHAPES[shapeKey(g)] + '</svg><span>' + esc(g) + '</span></button>';
      });
      return h + '</div>' + (c.gemNote ? '<p class="dc-b-hint">' + esc(c.gemNote) + '</p>' : '') + '</div>';
    };
    Stage.prototype.designsHTML = function () {
      var self = this, c = this.c, ds = this.opts.designs, lab = c.designLabel || 'Design';
      var h = '<div class="dc-b-group dc-b-g-design" data-b-group="design"><div class="dc-b-gh"><span class="dc-b-gl">' + esc(lab) + '</span><span class="dc-b-gv">' + esc(pretty(this.p.title)) + '</span>' + (c.allAnchor && document.getElementById(c.allAnchor) ? '<a class="dc-b-count dc-b-all" href="#' + esc(c.allAnchor) + '">' + esc(c.allLabel || 'See all designs') + '</a>' : '<span class="dc-b-count">' + ds.length + ' designs</span>') + '</div><div class="dc-b-designwrap"><button type="button" class="dc-b-dnav prev" data-b-dnav="-1" aria-label="Earlier designs" tabindex="-1">&#8249;</button><div class="dc-b-designs" role="group" aria-label="' + esc(lab) + '">';
      ds.forEach(function (d) {
        var lo = Math.min.apply(null, d.variants.map(function (x) { return x.p; }));
        var pic = d.thumb || (d.images[0] ? thumb(d.images[0]) : '');
        h += '<button type="button" class="dc-b-design' + (d.thumb ? ' is-art' : '') + '" data-b-design="' + esc(d.handle) + '" aria-pressed="' + (d.handle === self.p.handle) + '" title="' + esc(pretty(d.title)) + '" aria-label="' + esc(pretty(d.title)) + ', from ' + money(lo) + '">' + (pic ? '<img src="' + esc(pic) + '" alt="" decoding="async" width="240" height="240">' : '') + '</button>';
      });
      return h + '</div><button type="button" class="dc-b-dnav next" data-b-dnav="1" aria-label="More designs" tabindex="-1">&#8250;</button></div></div>';
    };
    Stage.prototype.mountExtras = function () {
      var p = this.p, el = this.el, box = el.querySelector('[data-b-terms]'), form = document.querySelector('form[data-dc-pt="' + p.handle + '"]');
      if (box && form) { if (!form._dcHome) form._dcHome = form.parentNode; box.appendChild(form); } else if (box) box.parentNode.removeChild(box);
      var icons = el.querySelector('[data-b-payicons]'), scope = this.opts.scope, tpl = (scope && scope.querySelector && scope.querySelector('template[data-b-payicons]')) || document.querySelector('template[data-b-payicons]');
      if (icons && tpl && tpl.content) icons.appendChild(tpl.content.cloneNode(true)); else if (icons) icons.parentNode.removeChild(icons);
    };
    Stage.prototype.render = function () {
      var self = this, p = this.p, c = this.c;
      var ii = this.imageIndex(); if (ii != null) this.img = ii;
      var main = p.images[this.img] || p.images[0] || '';
      var h = '<div class="dc-b-stage"><div class="dc-b-preview">';
      var vid = '';
      if (this.v360) vid = '<video class="dc-b-video" muted loop playsinline preload="none" data-src="' + esc(this.v360.hd || this.v360.sd) + '" data-src-mobile="' + esc(this.v360.sd || this.v360.hd) + '" aria-label="' + esc(this.v360.label || '360 degree view') + '"></video>' + '<span class="dc-b-360cap">360\u00b0 view' + (this.v360.stone ? ' \u00b7 ' + esc(this.v360.stone) : '') + (c.dragLabel ? ' \u00b7 ' + esc(c.dragLabel) : '') + '</span>';
      h += '<div class="dc-b-main' + (this.show360 ? ' is-360' : '') + '">' + (main ? '<img src="' + esc(main) + '" alt="' + esc(pretty(p.title)) + '" data-b-main>' : '') + vid + (c.badge ? '<span class="dc-b-badge">' + esc(c.badge) + '</span>' : '') + (this.gems.length > 1 || this.dia ? '<span class="dc-b-shapecap" data-b-shapecap hidden></span>' : '') + '<video class="dc-b-lvid" muted loop playsinline preload="none"></video><span class="dc-b-vidcap" data-b-vidcap></span></div>';
      if (p.images.length > 1 || this.v360 || this.pv.length || this.xv.length) {
        h += '<div class="dc-b-thumbs">';
        if (this.v360) h += '<button type="button" class="dc-b-thumb dc-b-thumb360" data-b-360 aria-label="360 degree view" aria-pressed="' + this.show360 + '">' + (main ? '<img src="' + esc(thumb(main)) + '" alt="" loading="lazy">' : '') + '<span>360\u00b0</span></button>';
        h += '<span class="dc-b-vthumbs" data-b-vthumbs></span>';
        p.images.slice(0, this.v360 ? 5 : 6).forEach(function (u, i) { h += '<button type="button" class="dc-b-thumb" data-b-thumb="' + i + '" aria-label="Photo ' + (i + 1) + '" aria-pressed="' + (i === self.img && !self.show360) + '"><img src="' + esc(thumb(u)) + '" alt="" loading="lazy"></button>'; });
        h += '</div>';
      }
      h += '<p class="dc-b-summary" data-b-summary></p></div>';
      h += '<div class="dc-b-panel"><p class="dc-eyebrow">' + esc(c.step2) + '</p><h3 class="dc-b-title">' + esc(pretty(p.title)) + '</h3><p class="dc-b-price" data-b-price></p>';
      h += '<div class="dc-b-terms" data-b-terms></div>';
      if (c.shipLine) h += '<p class="dc-b-ship">' + ICON.truck + '<span>' + esc(c.shipLine) + '</span></p>';
      if (this.opts.designs && this.opts.designs.length > 1) h += this.designsHTML();
      if (this.dog) h += this.breedHTML();
      if (this.gems.length > 1) h += this.gemHTML();
      // silver pieces whose one-value Metal option became Diamonds still say what they are made of
      var noMetal = c.fixedMetal && self.kinds.indexOf('metal') < 0 && self.kinds.indexOf('carat') < 0 && !/gold|platinum/i.test(p.title || '');
      var metalRow = noMetal ? '<div class="dc-b-group dc-b-fixedgroup dc-b-g-metal" data-b-group="metal"><div class="dc-b-gh"><span class="dc-b-gl">' + esc(LABEL.metal) + '</span>' + self.swatch('metal', c.fixedMetal) + '<span class="dc-b-gv">' + esc(short(c.fixedMetal, 'metal')) + '</span></div></div>' : '';
      p.options.forEach(function (n, i) { h += self.groupHTML(i); if (metalRow && self.kinds[i] === 'stone') { h += metalRow; metalRow = ''; } });
      if (metalRow) h += metalRow;
      if (this.shape) h += this.shapeHTML();
      if (this.psizes.length) h += this.psizeHTML();
      // the note for Andrew is always open: a labelled field people see without hunting for it
      var nid = 'dc-b-note-' + (++noteUid);
      h += '<div class="dc-b-group dc-b-note" data-b-group="note"><div class="dc-b-gh"><label class="dc-b-gl" for="' + nid + '">' + esc(c.notesLabel) + '</label><small class="dc-b-optional">optional</small></div><textarea id="' + nid + '" data-b-note rows="4" maxlength="500" placeholder="' + esc(c.notesPlaceholder) + '"></textarea></div>';
      h += '<div class="dc-b-cta"><p class="dc-b-error" role="alert" data-b-error></p>';
      h += '<button type="button" class="dc-btn solid dc-b-add" data-b-add><span>' + esc(c.addLabel) + '</span><span class="dc-b-addprice" data-b-addprice></span></button>';
      if (c.showBuy) h += '<button type="button" class="dc-btn dc-b-buy" data-b-buy>' + esc(c.buyLabel) + '</button>';
      h += '<div class="dc-b-success" data-b-success hidden></div></div>';
      var sb = shipBy(c); if (sb) h += '<p class="dc-b-delivery">' + ICON.cal + '<span>' + esc(sb) + '</span></p>';
      h += '<div class="dc-b-trust"><span class="dc-b-secure">' + ICON.lock + esc(c.secureLabel || 'Secure checkout') + '</span><span class="dc-b-payicons" data-b-payicons></span></div>';
      if (c.perks.length && c.showPerks !== false) h += '<ul class="dc-b-perks">' + c.perks.map(function (x) { return '<li>' + perkIcon(x) + '<span>' + esc(x) + '</span></li>'; }).join('') + '</ul>';
      if (c.quote) h += '<blockquote class="dc-b-quote"><span class="dc-b-stars" aria-label="5 out of 5 stars">\u2605\u2605\u2605\u2605\u2605</span><p>' + esc(c.quote) + '</p>' + (c.quoteBy ? '<cite>' + esc(c.quoteBy) + '</cite>' : '') + '</blockquote>';
      var drawer = document.querySelector('[data-dc-drawer]');
      h += '<div class="dc-b-more">';
      if (c.customLabel && (drawer || c.customLink)) h += drawer ? '<a class="dc-link" href="#customize" data-dc-customize>' + esc(c.customLabel) + '</a>' : '<a class="dc-link" href="' + esc(c.customLink) + '">' + esc(c.customLabel) + '</a>';
      h += '<a class="dc-b-details" href="' + esc(p.url) + '">' + esc(c.detailsLabel) + '</a></div>';
      h += '</div></div>';
      this.el.innerHTML = h;
      if (this.v360) { var st3 = this, vEl = this.el.querySelector('.dc-b-video'); dcVideo(vEl, this.el.querySelector('.dc-b-main'), false, function () { return st3.show360; }); dcSpin(vEl, this.el.querySelector('.dc-b-main'), function () { return st3.show360; }); }
      this.mountExtras();
      if (this.gems.length > 1) { var links = this.gemLinks; setTimeout(function () { links.forEach(function (gl) { if (gl && gl !== '-') listing(gl, function () {}); }); }, 1500); }
      var selD = this.el.querySelector('.dc-b-design[aria-pressed="true"]'), rowD = selD && selD.parentNode;
      var dRow = this.el.querySelector('.dc-b-designs'), dWrap = dRow && dRow.parentNode;
      if (dRow && dWrap) { var dEdges = function () { var max = dRow.scrollWidth - dRow.clientWidth; dWrap.classList.toggle('can-prev', dRow.scrollLeft > 4); dWrap.classList.toggle('can-next', dRow.scrollLeft < max - 4); }; dRow.addEventListener('scroll', dEdges, { passive: true }); setTimeout(dEdges, 60); window.addEventListener('resize', dEdges); }
      if (rowD && rowD.scrollWidth > rowD.clientWidth) rowD.scrollLeft = Math.max(0, selD.offsetLeft - rowD.offsetLeft - (rowD.clientWidth - selD.offsetWidth) / 2);
      this.bind();
      this.refresh();
    };
    Stage.prototype.set360 = function (on) {
      if (on && this.vidOn > -1) this.stopVid();
      this.show360 = !!on && !!this.v360;
      var wrap = this.el.querySelector('.dc-b-main'), vEl = this.el.querySelector('.dc-b-video'), k;
      if (wrap) wrap.classList.toggle('is-360', this.show360);
      var t3 = this.el.querySelector('[data-b-360]'); if (t3) t3.setAttribute('aria-pressed', this.show360 ? 'true' : 'false');
      var th = this.el.querySelectorAll('[data-b-thumb]');
      for (k = 0; k < th.length; k++) th[k].setAttribute('aria-pressed', !this.show360 && +th[k].getAttribute('data-b-thumb') === this.img ? 'true' : 'false');
      if (vEl) { if (this.show360) { if (vEl._dcPlay) vEl._dcPlay(); } else if (!vEl.paused) vEl.pause(); }
      this.gemCap();
    };
    Stage.prototype.setImg = function (i) {
      var u = this.p.images[i]; if (!u) return;
      if (this.vidOn > -1) this.stopVid();
      this.altOn = false; this.shown = this.gems[0] || '';
      if (this.show360) this.set360(false);
      this.img = i;
      var th = this.el.querySelectorAll('[data-b-thumb]'), k;
      this.showSrc(u);
      for (k = 0; k < th.length; k++) th[k].setAttribute('aria-pressed', +th[k].getAttribute('data-b-thumb') === i ? 'true' : 'false');
      this.gemCap();
    };
    // a diamond option is picked: any Diamonds value other than No diamond / Plain / None
    Stage.prototype.diaOn = function () { var ai = this.kinds.indexOf('accent'), v = ai > -1 ? this.sel[ai] : ''; return !!v && !/^(no\b|plain|none)/i.test(v); };
    Stage.prototype.diaLink = function () {
      if (!this.dia || !this.diaOn()) return '';
      var i = this.gems.length ? this.dia.s.indexOf(this.gem) : 0, h = i > -1 ? this.dia.l[i] : '';
      return h && h !== '-' ? h : '';
    };
    Stage.prototype.gemLink = function () { var i = this.gems.indexOf(this.gem), h = i > -1 ? this.gemLinks[i] : ''; return h && h !== '-' ? h : ''; };
    Stage.prototype.gemCap = function () {
      var cap = this.el.querySelector('[data-b-shapecap]'); if (!cap) return;
      var off = !!(this.gem && this.shown && this.shown !== this.gem && !this.show360), miss = !!(this.dia && this.diaOn() && !this.diaLink() && !this.show360);
      cap.hidden = !(off || miss);
      if (miss) cap.textContent = this.c.diaMissing;
      else if (off) cap.textContent = String(this.c.gemShown || '').replace('[shape]', this.shown);
    };
    Stage.prototype.showSrc = function (u) {
      var img = this.el.querySelector('[data-b-main]'); if (!img || !u) return;
      if (this.vidOn > -1) this.stopVid();
      img._dcWant = u;
      if (img.getAttribute('src') === u) { img.classList.remove('is-fading'); return; }
      img.classList.add('is-fading');
      var pre = new Image();
      pre.onload = pre.onerror = function () { if (img._dcWant !== u) return; img.src = u; img.classList.remove('is-fading'); };
      pre.src = u;
    };
    // videos for the shape on show: the product's own (first shape), the shape listing's own (other shapes), plus Videos by design links
    Stage.prototype.syncVids = function () {
      var self = this, g = this.gem || '', key = g;
      if (key === this.vidKey) return;
      this.vidKey = key;
      var auto = this._autoVid; this._autoVid = false;
      var h = this.gems.length && g !== this.gems[0] ? this.gemLink() : '';
      var files = []; this.xv.forEach(function (x) { if (!x.s || x.s === g) files.push(x.u); });
      var done = function (own) { vidList(JSON.stringify(own || []), files.join(','), function (list) { if (self.el._dcStage !== self || self.vidKey !== key) return; self.setVids(list, auto); }); };
      if (!h) done(this.pv.slice());
      else listing(h, function (lp) { done(lp ? mediaVids(lp.media) : []); });
    };
    Stage.prototype.setVids = function (list, auto) {
      this.vids = list || [];
      if (this.vidOn > -1) this.stopVid();
      var box = this.el.querySelector('[data-b-vthumbs]');
      if (box) box.innerHTML = this.vids.map(function (v, i) { return '<button type="button" class="dc-b-thumb dc-b-thumbvid" data-b-vid="' + i + '" aria-label="Video ' + (i + 1) + '" aria-pressed="false">' + (v.p ? '<img src="' + esc(v.p) + '" alt="" loading="lazy">' : '<video muted playsinline preload="metadata" src="' + esc(v.sd) + '#t=1.5" aria-hidden="true"></video>') + '<span class="dc-b-play" aria-hidden="true"></span></button>'; }).join('');
      if (auto && this.vids.length) this.playVid(0);
    };
    Stage.prototype.playVid = function (i) {
      var v = this.vids[i], wrap = this.el.querySelector('.dc-b-main'), el = this.el.querySelector('.dc-b-lvid'); if (!v || !wrap || !el) return;
      if (this.show360) this.set360(false);
      this.vidOn = i;
      var src = pickSrc(v);
      if (el.getAttribute('src') !== src) { el.setAttribute('src', src); if (v.p) el.setAttribute('poster', v.p); else el.removeAttribute('poster'); }
      wrap.classList.add('is-vid');
      var pr = el.play(); if (pr && pr.catch) pr.catch(function () {});
      var cap = this.el.querySelector('[data-b-vidcap]'); if (cap) cap.textContent = (this.c.videoLabel || 'Video') + (this.gem ? ' \u00b7 ' + this.gem : '');
      var t = this.el.querySelectorAll('[data-b-vid],[data-b-thumb],[data-b-360]'), k;
      for (k = 0; k < t.length; k++) t[k].setAttribute('aria-pressed', t[k].getAttribute('data-b-vid') === String(i) ? 'true' : 'false');
    };
    Stage.prototype.stopVid = function () {
      var wrap = this.el.querySelector('.dc-b-main'), el = this.el.querySelector('.dc-b-lvid'), t = this.el.querySelectorAll('[data-b-vid]'), k;
      this.vidOn = -1; if (wrap) wrap.classList.remove('is-vid'); if (el && !el.paused) el.pause();
      for (k = 0; k < t.length; k++) t[k].setAttribute('aria-pressed', 'false');
    };
    Stage.prototype.syncGem = function () {
      if (this.gems.length < 2 && !this.dia) return;
      var self = this, si = this.kinds.indexOf('stone'), stone = si > -1 ? this.sel[si] : '', dl = this.diaLink(), key = this.gem + '|' + stone + '|' + dl + '|' + this.diaOn(), h = dl || this.gemLink(), want = this.gem;
      if (key === this.gemKey) return;
      this.gemKey = key;
      if (!h) {
        var cur = this.el.querySelector('[data-b-main]');
        if (this.altOn) { var ii = this.imageIndex(); this.setImg(ii != null ? ii : this.img); }
        else if (cur) this.showSrc(cur._dcWant || cur.getAttribute('src'));
        this.gemCap(); return;
      }
      var mainImg = this.el.querySelector('[data-b-main]');
      if (mainImg) mainImg.classList.add('is-fading');
      listing(h, function (lp) {
        if (self.el._dcStage !== self || self.gem !== want || self.diaLink() !== dl) return;
        if (!lp) { if (mainImg) mainImg.classList.remove('is-fading'); return; }
        var v = null, src, th = self.el.querySelectorAll('[data-b-thumb]'), k;
        if (stone && lp.variants) v = lp.variants.filter(function (x) { return x.featured_image && (x.options || []).indexOf(stone) > -1; })[0];
        src = v ? v.featured_image.src : ((lp.images && lp.images[0]) || lp.featured_image || '');
        if (!src) { if (mainImg) mainImg.classList.remove('is-fading'); return; }
        if (self.show360) self.set360(false);
        self.altOn = true; self.shown = want; self.showSrc(sized(src));
        for (k = 0; k < th.length; k++) th[k].setAttribute('aria-pressed', 'false');
        self.gemCap();
      });
    };
    Stage.prototype.breedInfo = function () {
      var c = this.c, el = this.el, self = this, b = this.breed, a = el.querySelector('[data-b-breedlink]'), fig = el.querySelector('[data-b-breedprev]');
      var real = !!b && !/another/i.test(b);
      if (a) a.setAttribute('href', String(c.breedPage).split('#')[0] + (real ? '#breed-' + handle(b) : ''));
      var rost = el.querySelector('.dc-b-roster'), on = rost && rost.querySelector('[data-b-breed][aria-pressed="true"]');
      if (rost && on && (on.offsetLeft < rost.scrollLeft || on.offsetLeft + on.offsetWidth > rost.scrollLeft + rost.clientWidth)) rost.scrollLeft = Math.max(0, on.offsetLeft - rost.clientWidth / 2 + on.offsetWidth / 2);
      if (!fig) return;
      if (!real || !c.breedPreview) { fig.hidden = true; return; }
      breedPhoto(c.breedPage, b, function (src) {
        if (self.breed !== b) return;
        var img = fig.querySelector('[data-b-breedimg]'), cap = fig.querySelector('[data-b-breedcap]');
        if (!src || !img) { fig.hidden = true; return; }
        img.src = src; img.alt = b; if (cap) cap.textContent = String(c.breedPrevLabel || '').replace('[breed]', b);
        fig.hidden = false;
      });
    };
    Stage.prototype.refresh = function () {
      var self = this, el = this.el, p = this.p, c = this.c, k, b, i, v;
      var btns = el.querySelectorAll('[data-b-opt]');
      for (k = 0; k < btns.length; k++) {
        b = btns[k]; i = +b.getAttribute('data-b-opt'); v = b.getAttribute('data-b-val');
        b.setAttribute('aria-pressed', self.sel[i] === v ? 'true' : 'false');
        b.classList.toggle('is-na', !self.match(i).some(function (x) { return x.o[i] === v && x.a; }));
        var d = b.querySelector('[data-b-delta]');
        if (d) {
          var here = self.match(i).filter(function (x) { return x.o[i] === v; }), all = self.match(i);
          if (here.length && all.length) {
            var diff = Math.min.apply(null, here.map(function (x) { return x.p; })) - Math.min.apply(null, all.map(function (x) { return x.p; }));
            d.textContent = diff > 0 ? '+' + money(diff) : '';
          }
        }
      }
      for (i = 0; i < p.options.length; i++) {
        var gv = el.querySelector('[data-b-gv="' + i + '"]'); if (!gv) continue;
        var val = this.sel[i];
        gv.textContent = val ? short(val, this.kinds[i]) : (this.kinds[i] === 'size' ? c.chooseSize : '');
        gv.classList.toggle('is-empty', !val);
      }
      var bsel = el.querySelector('[data-b-breedsel]'); if (bsel && bsel.value !== this.breed) bsel.value = this.breed;
      var bg = el.querySelector('[data-b-gv="breed"]');
      if (bg) { bg.textContent = this.breed || c.chooseBreed; bg.classList.toggle('is-empty', !this.breed); }
      var bb = el.querySelectorAll('[data-b-breed]');
      for (k = 0; k < bb.length; k++) bb[k].setAttribute('aria-pressed', bb[k].getAttribute('data-b-breed') === self.breed ? 'true' : 'false');
      var sg = el.querySelector('[data-b-gv="shape"]'); if (sg) sg.textContent = this.shape;
      var gg = el.querySelector('[data-b-gv="gem"]'); if (gg) gg.textContent = this.gem;
      var gb = el.querySelectorAll('[data-b-gem]');
      for (k = 0; k < gb.length; k++) gb[k].setAttribute('aria-pressed', gb[k].getAttribute('data-b-gem') === self.gem ? 'true' : 'false');
      var pg = el.querySelector('[data-b-gv="psize"]'); if (pg) { pg.textContent = this.psize ? short(this.psize, 'size') : c.chooseSize; pg.classList.toggle('is-empty', !this.psize); }
      var pb = el.querySelectorAll('[data-b-psize]');
      for (k = 0; k < pb.length; k++) pb[k].setAttribute('aria-pressed', pb[k].getAttribute('data-b-psize') === self.psize ? 'true' : 'false');
      var sb = el.querySelectorAll('[data-b-shape]');
      for (k = 0; k < sb.length; k++) sb[k].setAttribute('aria-pressed', sb[k].getAttribute('data-b-shape') === self.shape ? 'true' : 'false');
      var cur = this.variant(), m = cur ? [cur] : this.match(-1), pr = el.querySelector('[data-b-price]');
      if (pr) {
        if (!m.length) pr.innerHTML = '<span>' + esc(c.unavailable) + '</span>';
        else {
          var lo = Math.min.apply(null, m.map(function (x) { return x.p; })), hi = Math.max.apply(null, m.map(function (x) { return x.p; }));
          pr.innerHTML = (lo !== hi ? '<small>From</small> ' : '') + '<b>' + money(lo) + '</b>' + (cur && cur.c && cur.c > cur.p ? '<s>' + money(cur.c) + '</s>' : '');
        }
      }
      var ap = el.querySelector('[data-b-addprice]'); if (ap) ap.textContent = cur ? money(cur.p) : '';
      var idIn = el.querySelector('form[data-dc-pt] input[name="id"]'), fv = cur || this.match(-1)[0];
      if (idIn && fv && String(idIn.value) !== String(fv.i)) { idIn.value = fv.i; idIn.dispatchEvent(new Event('change', { bubbles: true })); var pt = el.querySelector('shopify-payment-terms'); if (pt) pt.setAttribute('variant-id', fv.i); }
      if (!this.altOn) { var ii = this.imageIndex(); if (ii != null && ii !== this.img) this.setImg(ii); }
      this.syncGem();
      this.syncVids();
      var parts = [];
      if (this.breed) parts.push(this.breed);
      this.sel.forEach(function (x, j) { if (x && self.vals[j].length > 1) parts.push((self.kinds[j] === 'size' ? 'Size ' : '') + short(x, self.kinds[j])); });
      if (this.shape) parts.push(this.shape);
      if (this.psize) parts.push('Size ' + short(this.psize, 'size'));
      if (this.gems.length > 1 && this.gem) parts.push(this.gem);
      var sm = el.querySelector('[data-b-summary]'); if (sm) sm.textContent = parts.join(' · ');
      if (this.onChange) this.onChange(this);
    };
    Stage.prototype.pick = function (i, v) {
      if (this.vidOn > -1) this.stopVid();
      this.sel[i] = v;
      if (!this.match(-1).length) {
        var self = this, keep = this.p.variants.filter(function (x) { return x.o[i] === v; })[0];
        if (keep) this.sel = this.sel.map(function (x, j) { return j === i || x == null ? x : (self.p.variants.some(function (y) { return y.o[i] === v && y.o[j] === x; }) ? x : keep.o[j]); });
      }
      this.clearMissing(String(i));
      this.refresh();
    };
    Stage.prototype.clearMissing = function (key) {
      var g = this.el.querySelector('[data-b-group="' + key + '"]'); if (g) g.classList.remove('is-missing');
      var e = this.el.querySelector('[data-b-error]'); if (e) e.textContent = '';
    };
    Stage.prototype.missing = function () {
      if (this.dog && !this.breed) return { key: 'breed', msg: this.c.chooseBreed };
      for (var i = 0; i < this.sel.length; i++) if (this.sel[i] == null) return { key: String(i), msg: this.kinds[i] === 'size' ? this.c.chooseSize : 'Choose ' + String(LABEL[this.kinds[i]] || this.p.options[i]).toLowerCase() };
      if (this.psizes.length && !this.psize) return { key: 'psize', msg: this.c.chooseSize };
      return null;
    };
    Stage.prototype.search = function (q) {
      q = String(q || '').toLowerCase().trim();
      var bb = this.el.querySelectorAll('[data-b-breed]'), k;
      var hits = 0;
      for (k = 0; k < bb.length; k++) { var name = bb[k].getAttribute('data-b-breed').toLowerCase(), other = /another/.test(name); bb[k].hidden = !!q && name.indexOf(q) < 0 && !other; if (!bb[k].hidden && !other) hits++; }
      var nm = this.el.querySelector('[data-b-nomatch]'); if (nm) nm.hidden = !q || hits > 0;
      var ro = this.el.querySelector('.dc-b-roster'); if (ro) ro.scrollLeft = 0;
    };
    Stage.prototype.submit = function (buy) {
      var self = this, el = this.el, err = el.querySelector('[data-b-error]'), miss = this.missing();
      if (miss) {
        if (err) err.textContent = miss.msg;
        var g = el.querySelector('[data-b-group="' + miss.key + '"]');
        if (g) { g.classList.remove('is-missing'); void g.offsetWidth; g.classList.add('is-missing'); g.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
      var v = this.variant();
      if (!v) { if (err) err.textContent = this.c.unavailable; return; }
      var props = {};
      if (this.breed) props[this.c.breedProp] = this.breed;
      if (this.shape) props[this.c.shapeProp] = this.shape;
      if (this.psize) props[this.c.sizeProp] = /^other/i.test(this.psize) ? this.c.otherSize : this.psize;
      if (this.gems.length > 1 && this.gem) props[this.c.gemProp] = this.gem;
      if (this.note) props[this.c.noteProp] = this.note.slice(0, 500);
      if (this.c.source) props['_Source'] = this.c.source;
      var btns = el.querySelectorAll('[data-b-add],[data-b-buy]'), k;
      for (k = 0; k < btns.length; k++) btns[k].setAttribute('aria-busy', 'true');
      if (err) err.textContent = '';
      fetch(base() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: v.i, quantity: 1, properties: props }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || self.c.addError); return j; }); })
        .then(function () {
          if (buy) { window.location.href = base() + 'checkout'; return; }
          for (k = 0; k < btns.length; k++) btns[k].removeAttribute('aria-busy');
          self.success();
          cartCount();
        })
        .catch(function (e) {
          for (k = 0; k < btns.length; k++) btns[k].removeAttribute('aria-busy');
          if (err) err.textContent = (e && e.message) || self.c.addError;
        });
    };
    Stage.prototype.success = function () {
      var box = this.el.querySelector('[data-b-success]'); if (!box) return;
      var sm = this.el.querySelector('[data-b-summary]');
      box.innerHTML = '<p class="dc-b-success-h" tabindex="-1">' + ICON.check + '<span>' + esc(this.c.successHeading) + '</span></p><p class="dc-b-success-item">' + esc(pretty(this.p.title)) + (sm && sm.textContent ? ' · ' + esc(sm.textContent) : '') + '</p><div class="dc-b-success-ctas"><a class="dc-btn solid" href="' + base() + 'checkout">' + esc(this.c.checkoutLabel) + '</a><a class="dc-btn" href="' + base() + 'cart">' + esc(this.c.cartLabel) + '</a></div>';
      box.hidden = false;
      var h = box.querySelector('.dc-b-success-h'); if (h) h.focus();
    };
    Stage.prototype.bind = function () {
      var el = this.el;
      if (el._dcBound) return; el._dcBound = true;
      el.addEventListener('click', function (e) {
        var st = el._dcStage, t = e.target.closest ? e.target.closest('button') : null;
        if (!st || !t || !el.contains(t)) return;
        if (t.hasAttribute('data-b-opt')) st.pick(+t.getAttribute('data-b-opt'), t.getAttribute('data-b-val'));
        else if (t.hasAttribute('data-b-360')) st.set360(true);
        else if (t.hasAttribute('data-b-thumb')) { var ti = +t.getAttribute('data-b-thumb'); if (ti === st.img && st.show360) st.set360(false); else st.setImg(ti); }
        else if (t.hasAttribute('data-b-design')) { if (st.opts.onDesign) st.opts.onDesign(t.getAttribute('data-b-design')); }
        else if (t.hasAttribute('data-b-breed')) {
          st.breed = t.getAttribute('data-b-breed'); st.clearMissing('breed'); st.refresh(); st.breedInfo();
          if (/another/i.test(st.breed)) { var d = el.querySelector('.dc-b-note'), ta = el.querySelector('[data-b-note]'); if (d) d.open = true; if (ta) ta.focus(); }
        }
        else if (t.hasAttribute('data-b-shape')) { st.shape = t.getAttribute('data-b-shape'); st.refresh(); }
        else if (t.hasAttribute('data-b-psize')) { st.psize = t.getAttribute('data-b-psize'); st.clearMissing('psize'); st.refresh(); }
        else if (t.hasAttribute('data-b-gem')) { st.gem = t.getAttribute('data-b-gem'); st._autoVid = true; st.refresh(); }
        else if (t.hasAttribute('data-b-vid')) st.playVid(+t.getAttribute('data-b-vid'));
        else if (t.hasAttribute('data-b-dnav')) { var dr = el.querySelector('.dc-b-designs'); if (dr) dr.scrollBy({ left: (+t.getAttribute('data-b-dnav')) * dr.clientWidth * 0.8, behavior: 'smooth' }); }
        else if (t.hasAttribute('data-b-rnav')) { var ro = el.querySelector('.dc-b-roster'); if (ro) ro.scrollBy({ left: (+t.getAttribute('data-b-rnav')) * ro.clientWidth * 0.8, behavior: 'smooth' }); }
        else if (t.hasAttribute('data-b-add')) st.submit(false);
        else if (t.hasAttribute('data-b-buy')) st.submit(true);
      });
      el.addEventListener('pointerover', function (e) {
        var st = el._dcStage, g = e.target.closest ? e.target.closest('[data-b-gem]') : null; if (!st || !g) return;
        var gi = st.gems.indexOf(g.getAttribute('data-b-gem')), gh = gi > -1 ? st.gemLinks[gi] : '';
        if (gh && gh !== '-') listing(gh, function () {});
      });
      el.addEventListener('change', function (e) {
        var st = el._dcStage, t = e.target; if (!st || !t || !t.hasAttribute || !t.hasAttribute('data-b-breedsel')) return;
        st.breed = t.value; st.clearMissing('breed'); st.refresh(); st.breedInfo();
        if (/another/i.test(st.breed)) { var d = el.querySelector('.dc-b-note'), ta = el.querySelector('[data-b-note]'); if (d) d.open = true; if (ta) ta.focus(); }
      });
      el.addEventListener('input', function (e) {
        var st = el._dcStage; if (!st || !e.target) return;
        if (e.target.hasAttribute('data-b-note')) st.note = e.target.value;
        if (e.target.hasAttribute('data-b-search')) st.search(e.target.value);
      });
    };

    /* quick buy window */
    var lastTrigger = null;
    function modal() {
      var m = document.getElementById('dc-qb');
      if (m) return m;
      m = document.createElement('div');
      m.id = 'dc-qb'; m.className = 'dc dc-qb'; m.hidden = true;
      m.innerHTML = '<div class="dc-qb-overlay" data-qb-close></div><div class="dc-qb-dialog" role="dialog" aria-modal="true" aria-label="Customize and buy"><button type="button" class="dc-qb-close" data-qb-close aria-label="Close">&times;</button><div class="dc-qb-body"></div></div>';
      document.body.appendChild(m);
      m.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-qb-close]')) closeQuick(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) closeQuick(); });
      return m;
    }
    function openQuick(h, scope, trigger, breed) {
      var p = product(h); if (!p) return false;
      var m = modal(), body = m.querySelector('.dc-qb-body');
      var st = new Stage(body, p, cfgFrom(scope), { scope: scope });
      if (breed && st.dog) { var hb = handle(breed); st.breed = list(st.c.breeds).filter(function (x) { return handle(x) === hb; })[0] || breed; st.refresh(); st.breedInfo(); }
      lastTrigger = trigger || null;
      m.hidden = false; void m.offsetWidth; m.classList.add('is-open');
      if (breed && st.dog) st.breedInfo();
      document.body.classList.add('dc-drawer-lock');
      var x = m.querySelector('.dc-qb-close'); if (x) x.focus();
      return true;
    }
    function closeQuick() {
      var m = document.getElementById('dc-qb'); if (!m) return;
      m.classList.remove('is-open'); document.body.classList.remove('dc-drawer-lock');
      setTimeout(function () { if (!m.classList.contains('is-open')) m.hidden = true; }, 320);
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }

    /* builder section */
    function mountBuilder(root) {
      if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
      var c = cfgFrom(root), stageEl = root.querySelector('[data-dc-stage]'); if (!stageEl) return;
      var tiles = root.querySelectorAll('[data-dc-pick]'), bar = root.querySelector('[data-b-bar]'), current = null, designs = [];
      var sets = { a: [], b: [] }, setOf = {}, setBtns = root.querySelectorAll('[data-b-set]'), activeSet = 'a';
      var dj = root.querySelectorAll('script[data-dc-product]');
      for (var di = 0; di < dj.length; di++) {
        var dp = product(dj[di].getAttribute('data-dc-product')), cell = dj[di].closest ? dj[di].closest('[data-dc-set]') : null, sk = cell && cell.getAttribute('data-dc-set') === 'b' ? 'b' : 'a';
        if (!dp) continue;
        if (sets[sk].indexOf(dp) < 0) sets[sk].push(dp);
        if (!setOf[dp.handle]) setOf[dp.handle] = sk;
      }
      if (c.layout === 'buybox') designs = sets.a;
      function useSet(k) {
        if (!sets[k] || !sets[k].length) return;
        activeSet = k; if (c.layout === 'buybox') designs = sets[k];
        for (var si = 0; si < setBtns.length; si++) setBtns[si].setAttribute('aria-pressed', setBtns[si].getAttribute('data-b-set') === k ? 'true' : 'false');
        var cells = root.querySelectorAll('.dc-build-cell[data-dc-set]');
        for (var ci = 0; ci < cells.length; ci++) cells[ci].hidden = !!setBtns.length && cells[ci].getAttribute('data-dc-set') !== k;
      }
      if (setBtns.length) useSet('a');
      var barTitle = bar && bar.querySelector('[data-b-bar-title]'), barPrice = bar && bar.querySelector('[data-b-bar-price]');
      var watchCta = function () {};
      function syncBar(st) {
        current = st; if (!bar) return;
        if (barTitle) barTitle.textContent = pretty(st.p.title);
        var v = st.variant(), m = v ? [v] : st.match(-1);
        if (barPrice && m.length) barPrice.textContent = (v ? '' : 'From ') + money(Math.min.apply(null, m.map(function (x) { return x.p; })));
      }
      function pick(h, scroll) {
        var p = product(h); if (!p) return false;
        if (setBtns.length && setOf[h] && setOf[h] !== activeSet) useSet(setOf[h]);
        for (var i = 0; i < tiles.length; i++) tiles[i].setAttribute('aria-pressed', tiles[i].getAttribute('data-dc-pick') === h ? 'true' : 'false');
        var keepBreed = current && current.breed;
        var st = new Stage(stageEl, p, c, { scope: root, designs: designs, onDesign: function (dh) { pick(dh, false); } }); st.onChange = syncBar; syncBar(st); watchCta();
        if (keepBreed && st.dog) { st.breed = keepBreed; st.refresh(); st.breedInfo(); }
        if (scroll) { var top = stageEl.getBoundingClientRect().top + window.pageYOffset - 84; window.scrollTo({ top: top, behavior: 'smooth' }); }
        return true;
      }
      root._dcPick = pick;
      root._dcCurrent = function () { return current; };
      root.addEventListener('click', function (e) {
        var sb = e.target.closest && e.target.closest('[data-b-set]');
        if (sb && root.contains(sb)) {
          var k = sb.getAttribute('data-b-set'); if (k === activeSet) return;
          var dflt = k === 'b' ? c.defaultDesignB : c.defaultDesign;
          useSet(k); pick(dflt && setOf[dflt] === k ? dflt : (sets[k][0] && sets[k][0].handle), false);
          return;
        }
        var t = e.target.closest && e.target.closest('[data-dc-pick]');
        if (t && root.contains(t)) { pick(t.getAttribute('data-dc-pick'), window.innerWidth < 990); return; }
        if (e.target.closest && e.target.closest('[data-b-bar-add]') && current) current.submit(false);
      });
      var q = null; try { q = new URLSearchParams(window.location.search).get('design'); } catch (er) { q = null; }
      var first = q && product(q) ? q : (c.defaultDesign && product(c.defaultDesign) ? c.defaultDesign : (tiles[0] ? tiles[0].getAttribute('data-dc-pick') : null));
      if (first) pick(first, false);
      try {
        var sp = new URLSearchParams(window.location.search), want = { stone: sp.get('stone'), metal: sp.get('metal') };
        if (current && (want.stone || want.metal)) current.kinds.forEach(function (k, i) { var w = want[k]; if (!w) return; var hw = handle(w), hit = current.vals[i].filter(function (v) { return handle(v).indexOf(hw) > -1; })[0]; if (hit) current.pick(i, hit); });
      } catch (er2) {}
      try {
        var wb = new URLSearchParams(window.location.search).get('breed');
        if (wb && current && current.dog) { var hb = handle(wb), bn = list(c.breeds).filter(function (x) { return handle(x) === hb; })[0]; if (bn) { current.breed = bn; current.refresh(); current.breedInfo(); } }
      } catch (er3) {}
      if (bar && 'IntersectionObserver' in window) {
        var stageIn = false, ctaIn = false, curCta = null;
        var apply = function () {
          var on = stageIn && !ctaIn;
          bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          var bt = bar.querySelector('[data-b-bar-add]'); if (bt) bt.tabIndex = on ? 0 : -1;
          document.body.classList.toggle('dc-b-bar-on', on);
        };
        new IntersectionObserver(function (en) { stageIn = en[en.length - 1].isIntersecting; apply(); }, { rootMargin: '0px 0px -30% 0px' }).observe(stageEl);
        var ctaObs = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.target === curCta) ctaIn = x.isIntersecting; }); apply(); });
        watchCta = function () {
          var cta = stageEl.querySelector('.dc-b-cta'); if (cta === curCta) return;
          if (curCta) ctaObs.unobserve(curCta);
          curCta = cta; ctaIn = false; if (cta) ctaObs.observe(cta);
        };
        watchCta();
      }
    }

    var globalBound = false;
    function bindGlobal() {
      if (globalBound) return; globalBound = true;
      document.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        var qb = e.target.closest('[data-dc-quick]');
        if (qb) { if (openQuick(qb.getAttribute('data-dc-quick'), qb.closest('[data-dc-quickscope]'), qb, qb.getAttribute('data-dc-quick-breed'))) e.preventDefault(); return; }
        var bt = e.target.closest('[data-dc-build]');
        if (bt) {
          var h = bt.getAttribute('data-dc-build'), b = document.querySelector('[data-dc-builder]');
          if (b && b._dcPick && product(h)) {
            e.preventDefault(); b._dcPick(h, true);
            var want = bt.getAttribute('data-dc-pick-stone'), cur = b._dcCurrent && b._dcCurrent();
            if (want && cur) { var si2 = cur.kinds.indexOf('stone'), hw = handle(want); if (si2 > -1) { var hv = cur.vals[si2].filter(function (v) { return handle(v) === hw; })[0]; if (hv) cur.pick(si2, hv); } }
          }
          else if (product(h)) { e.preventDefault(); openQuick(h, null, bt); }
        }
      });
    }
    /* ---------- product page options as buttons (the diamond add-on rings): +$ adders, stone and metal dots ---------- */
    function mountPills(el) {
      if (!el || el._dcPills) return;
      var vr = el.querySelector('variant-radios'), js = vr && vr.querySelector('script[type="application/json"]'); if (!vr || !js) return;
      var vs = parse(js.textContent); if (!Array.isArray(vs) || !vs.length) return;
      el._dcPills = true;
      vs = vs.map(function (v) { return { o: v.options || [], p: v.price, a: v.available }; });
      var sets = [].slice.call(vr.querySelectorAll('fieldset'));
      var kinds = sets.map(function (f, i) { var l = f.querySelector('legend'), vals = []; vs.forEach(function (v) { if (vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); }); return kindOf(l ? l.textContent.trim() : '', vals); });
      var radios = function (f) { return [].slice.call(f.querySelectorAll('input[type="radio"]')); }, labels = [];
      sets.forEach(function (f, i) {
        var k = kinds[i]; f.classList.add('dc-pp-' + k); if (radios(f).length < 2) f.classList.add('dc-pp-single');
        radios(f).forEach(function (inp) {
          var lab = inp.nextElementSibling; if (!lab || lab.tagName !== 'LABEL') return;
          if (k === 'stone' || k === 'metal') { var d = document.createElement('span'); d.className = k === 'stone' ? 'dc-gem-dot' : 'dc-metal-dot'; d.setAttribute(k === 'stone' ? 'data-gem' : 'data-metal', handle(inp.value)); d.setAttribute('aria-hidden', 'true'); lab.insertBefore(d, lab.firstChild); }
          if (k === 'accent' || k === 'carat' || k === 'metal') { var sm = document.createElement('small'); sm.className = 'dc-pp-delta'; sm.setAttribute('data-dc-delta', ''); lab.appendChild(sm); }
        });
        // 'Diamonds: Hidden halo' becomes a small label and the value, again after the theme swaps the text in
        var nm = f.querySelector('.product-group-name > span');
        if (nm) {
          var split = function () { var t = nm.textContent, at = t.indexOf(':'); if (nm.querySelector('b') || at < 0) return; nm.innerHTML = '<b>' + esc(LABEL[k] || t.slice(0, at).trim()) + '</b> <span>' + esc(t.slice(at + 1).trim()) + '</span>'; };
          split(); if (window.MutationObserver) new MutationObserver(split).observe(nm, { childList: true, characterData: true, subtree: true });
          var lg = f.querySelector('legend'), nameT = LABEL[k] || (lg ? lg.textContent.trim() : '');
          labels.push(function () { var c = f.querySelector('input[type="radio"]:checked'); if (c) nm.innerHTML = '<b>' + esc(nameT) + '</b> <span>' + esc(c.value) + '</span>'; });
        }
      });
      var update = function () {
        var cur = sets.map(function (f) { var c = f.querySelector('input[type="radio"]:checked'); return c ? c.value : null; });
        sets.forEach(function (f, i) {
          if (!f.querySelector('[data-dc-delta]')) return;
          var rest = vs.filter(function (v) { for (var j = 0; j < cur.length; j++) if (j !== i && cur[j] != null && v.o[j] !== cur[j]) return false; return true; });
          if (!rest.length) return;
          var lo = Math.min.apply(null, rest.map(function (v) { return v.p; }));
          radios(f).forEach(function (inp) {
            var d = inp.nextElementSibling && inp.nextElementSibling.querySelector('[data-dc-delta]'); if (!d) return;
            var here = rest.filter(function (v) { return v.o[i] === inp.value; });
            var diff = here.length ? Math.min.apply(null, here.map(function (v) { return v.p; })) - lo : 0;
            d.textContent = diff > 0 ? '+' + money(diff) : '';
          });
        });
      };
      var diaEl = el.querySelector('script[data-dc-dia]'), dia = diaEl ? parse(diaEl.textContent) : null, note = el.querySelector('[data-dc-dia-note]');
      var picked = function (kind) { var i = kinds.indexOf(kind), c = i > -1 ? sets[i].querySelector('input[type="radio"]:checked') : null; return c ? c.value : ''; };
      var swapMain = function (url) {
        var imgs = [document.querySelector('.product__media-list .product__media-item img'), document.querySelector('.product__media-sublist .product__media-subitem img')];
        imgs.forEach(function (im) {
          if (!im) return;
          if (url) { if (im.getAttribute('data-dc-orig') == null) { im.setAttribute('data-dc-orig', im.getAttribute('src') || ''); im.setAttribute('data-dc-origset', im.getAttribute('srcset') || ''); } im.removeAttribute('srcset'); im.setAttribute('src', url); }
          else if (im.getAttribute('data-dc-orig') != null) { im.setAttribute('src', im.getAttribute('data-dc-orig')); var os = im.getAttribute('data-dc-origset'); if (os) im.setAttribute('srcset', os); im.removeAttribute('data-dc-orig'); im.removeAttribute('data-dc-origset'); }
        });
        if (url) { var gv = document.querySelector('[data-dc-gemvid]'); if (gv) gv.remove(); }
        var sw = document.querySelector('.product__media-list .js-media-list'); if (url && sw && sw.swiper && sw.swiper.slideTo) sw.swiper.slideTo(0);
      };
      var syncDia = function () {
        if (!dia || !Array.isArray(dia.shapes)) return;
        var dv = picked('accent'), on = !!dv && !/^(no\b|plain|none)/i.test(dv);
        var g = document.querySelector('[data-dc-gem-field] input[type="radio"]:checked'), shp = g ? g.value : '';
        var ent = dia.shapes.filter(function (x) { return x.s === shp; })[0] || (shp ? null : dia.shapes[0]);
        var st = picked('stone'), url = on && ent ? (ent.img[st] || ent.img[Object.keys(ent.img)[0]] || '') : '';
        swapMain(url);
        if (note) note.hidden = !(on && !url);
      };
      document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('[data-dc-gem-field]')) syncDia(); });
      vr.addEventListener('change', function () { setTimeout(function () { labels.forEach(function (fn) { fn(); }); update(); syncDia(); }, 0); });
      update(); syncDia();
    }

    return { mount: mountBuilder, bind: bindGlobal, open: openQuick, close: closeQuick, breedPhoto: breedPhoto, handle: handle, pills: mountPills };
  })();


  /* ---------- shop all designs: category tabs with live counts ---------- */
  function mountShopGrid(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var cards = root.querySelectorAll('[data-sg-cat]'), tabs = root.querySelectorAll('[data-sg-tab]'), counts = { all: cards.length }, i, shownTabs = 0;
    for (i = 0; i < cards.length; i++) { var cat = cards[i].getAttribute('data-sg-cat'); counts[cat] = (counts[cat] || 0) + 1; }
    for (i = 0; i < tabs.length; i++) {
      var k = tabs[i].getAttribute('data-sg-tab'), n = counts[k] || 0, sm = tabs[i].querySelector('[data-sg-count]');
      if (sm) sm.textContent = n;
      tabs[i].hidden = !n; if (n) shownTabs++;
    }
    var bar = root.querySelector('.dc-sg-tabs'); if (bar && shownTabs < 3) bar.hidden = true;
    root.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-sg-tab]'); if (!t || !root.contains(t)) return;
      var key = t.getAttribute('data-sg-tab');
      for (var j = 0; j < tabs.length; j++) tabs[j].setAttribute('aria-pressed', tabs[j] === t ? 'true' : 'false');
      for (var j2 = 0; j2 < cards.length; j2++) cards[j2].hidden = !(key === 'all' || cards[j2].getAttribute('data-sg-cat') === key);
      limit();
    });
    // phones and tablets: show the first few designs of the chosen tab, then a Show all button
    var max = parseInt(root.getAttribute('data-sg-limit'), 10) || 0, more = root.querySelector('[data-sg-more]'), wrapMore = more && more.parentNode, all = false;
    function limit() {
      if (!more || !max) return;
      var vis = [], k;
      for (k = 0; k < cards.length; k++) { cards[k].classList.remove('is-more'); if (!cards[k].hidden) vis.push(cards[k]); }
      var extra = all ? 0 : vis.length - max;
      for (k = max; k < vis.length && extra > 0; k++) vis[k].classList.add('is-more');
      wrapMore.hidden = extra <= 0;
      more.textContent = (more.getAttribute('data-label') || '').replace('[count]', vis.length);
    }
    if (more) more.addEventListener('click', function () {
      var first = root.querySelector('.dc-sg-card.is-more'); all = true; limit();
      if (first) { var fl = first.querySelector('.dc-qb-btn, a'); if (fl) fl.focus({ preventScroll: true }); }
    });
    limit();
  }

  /* ---------- videos: a Content > Files link becomes the light 720p / 480p copies Shopify makes of it ---------- */
  var VIDSRC = {};
  function dcVidSrc(u, cb) {
    u = String(u || '').trim(); if (!u) { cb(null); return; }
    var m = u.match(/\/videos\/c\/(?:o\/v|vp)\/([0-9a-f]{32})/);
    if (!m) { cb({ hd: u, sd: u }); return; }
    var id = m[1], x = VIDSRC[id];
    if (x && x.done) { cb(x.v); return; }
    if (x) { x.cbs.push(cb); return; }
    x = VIDSRC[id] = { done: false, v: null, cbs: [cb] };
    var fin = function (v) { x.done = true; x.v = v; x.cbs.splice(0).forEach(function (f) { f(v); }); };
    var base = 'https://cdn.shopify.com/videos/c/vp/' + id + '/' + id;
    fetch(base + '.m3u8').then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) {
      var out = {}, re = new RegExp(id + '\\.(HD-1080p|HD-720p|SD-480p)\\.([0-9.]+)Mbps\\.hls\\.(\\d+)_', 'g'), mm;
      while ((mm = re.exec(t))) out[mm[1]] = base + '.' + mm[1] + '-' + mm[2] + 'Mbps-' + mm[3] + '.mp4';
      var hd = out['HD-720p'] || out['HD-1080p'] || out['SD-480p'], sd = out['SD-480p'] || hd;
      fin(hd ? { hd: hd, sd: sd } : { hd: u, sd: u });
    }).catch(function () { fin({ hd: u, sd: u }); });
  }
  // videos attached to a product, from its /products/handle.js media
  function mediaVids(media) {
    var out = [];
    (media || []).forEach(function (m) {
      if (!m || m.media_type !== 'video') return;
      var hd = '', sd = '', big = '';
      (m.sources || []).forEach(function (so) {
        if (so.format !== 'mp4') return;
        var px = Math.min(so.width || 9999, so.height || 9999);
        if (px <= 540) { if (!sd) sd = so.url; } else if (px <= 800) hd = so.url; else if (!big) big = so.url;
      });
      hd = hd || big || sd; sd = sd || hd;
      if (hd) out.push({ hd: hd, sd: sd, p: m.preview_image ? (m.preview_image.src || '') : '' });
    });
    return out;
  }
  function vidList(json, files, cb) {
    var own = []; try { own = JSON.parse(json || '[]') || []; } catch (e) { own = []; }
    var urls = String(files || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean), all = own.concat(urls), out = new Array(all.length), left = all.length;
    if (!left) { cb([]); return; }
    all.forEach(function (x, i) {
      var put = function (v) { out[i] = v; if (--left === 0) cb(out.filter(Boolean)); };
      if (typeof x === 'string') { dcVidSrc(x, put); return; }
      // the server hands product videos over as the 1080p copy only: find the light copies through the playlist
      if (!x || !x.hd || (x.sd && x.sd !== x.hd && !/HD-1080p/.test(x.hd))) { put(x); return; }
      dcVidSrc(x.hd, function (v) { put({ hd: (v && v.hd) || x.hd, sd: (v && v.sd) || x.sd || x.hd, p: x.p }); });
    });
  }
  function pickSrc(v) { return v ? (window.innerWidth < 760 ? (v.sd || v.hd) : (v.hd || v.sd)) : ''; }

  /* ---------- lazy video: loads when in view, after the page has loaded; pauses out of view; phones get the light file ---------- */
  function dcVideo(v, wrap, eager, canPlay) {
    if (!v || v._dcV) return; v._dcV = true;
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var conn = navigator.connection || {}, save = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    var reduce = !!(mq && mq.matches), small = window.innerWidth < 760;
    var src = (small || save) ? (v.getAttribute('data-src-mobile') || v.getAttribute('data-src')) : (v.getAttribute('data-src') || v.getAttribute('data-src-mobile'));
    var btn = wrap && wrap.querySelector('[data-video-play]');
    v.addEventListener('playing', function () { if (wrap) wrap.classList.add('is-playing'); if (btn) btn.hidden = true; });
    function play() {
      if (!src || (canPlay && !canPlay())) return;
      if (!v.getAttribute('src')) v.src = src;
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () { if (btn) btn.hidden = false; });
    }
    v._dcPlay = play;
    if (btn) btn.addEventListener('click', function () { play(); });
    if (reduce || save) { if (btn) btn.hidden = false; return; }
    function watch() {
      if (!('IntersectionObserver' in window)) { play(); return; }
      new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) play(); else if (!v.paused) v.pause(); }); }, { threshold: 0.15 }).observe(wrap || v);
    }
    if (eager || document.readyState === 'complete') setTimeout(watch, eager ? 0 : 400);
    else window.addEventListener('load', function () { setTimeout(watch, 700); });
  }
  function dcSpin(v, surface, active) {
    if (!v || !surface || surface._dcSpin) return; surface._dcSpin = true;
    surface.classList.add('dc-spinnable');
    var drag = null, resume = 0, raf = 0, want = null;
    function seek() { raf = 0; if (want == null) return; if (v.seeking) { raf = requestAnimationFrame(seek); return; } try { v.currentTime = want; } catch (e) {} want = null; }
    surface.addEventListener('dragstart', function (e) { if (surface.classList.contains('is-spinning')) e.preventDefault(); });
    surface.addEventListener('pointerdown', function (e) {
      if ((e.button && e.button > 0) || (active && !active()) || !v.duration || !isFinite(v.duration) || v.readyState < 1) return;
      drag = { x: e.clientX, t: v.currentTime, w: surface.getBoundingClientRect().width || 1, moved: false, id: e.pointerId };
      clearTimeout(resume);
    });
    surface.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) { if (Math.abs(dx) < 6) return; drag.moved = true; try { surface.setPointerCapture(e.pointerId); } catch (er) {} if (!v.paused) v.pause(); surface.classList.add('is-spinning'); }
      var d = v.duration, t = drag.t + dx / drag.w * d;
      want = ((t % d) + d) % d; if (!raf) raf = requestAnimationFrame(seek);
      if (e.cancelable) e.preventDefault();
    });
    function end(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var moved = drag.moved; drag = null;
      if (!moved) return;
      setTimeout(function () { surface.classList.remove('is-spinning'); }, 0);
      resume = setTimeout(function () { if (!drag && (!active || active()) && v._dcPlay) v._dcPlay(); }, 2500);
    }
    surface.addEventListener('pointerup', end); surface.addEventListener('pointercancel', end);
    surface.addEventListener('click', function (e) { if (surface.classList.contains('is-spinning')) { e.preventDefault(); e.stopPropagation(); } }, true);
  }
  function mountVideoWrap(wrap) {
    if (wrap.dataset.dcMounted) return; wrap.dataset.dcMounted = '1';
    var v = wrap.querySelector('video[data-dc-video]');
    dcVideo(v, wrap, !!(v && v.hasAttribute('data-dc-eager')));
    if (wrap.hasAttribute('data-dc-spin')) dcSpin(v, wrap);
  }

  /* ---------- product page: the theme form has novalidate, so required DC choices (ring size, breed) are checked here, before Add to cart and Buy it now ---------- */
  var REQ_BOUND = false;
  function productFormGuard() {
    if (REQ_BOUND) return; REQ_BOUND = true;
    var missing = function (form) {
      // getAttribute: the theme form holds an input named id, which form.id would return instead
      var fid = form && form.getAttribute ? form.getAttribute('id') : ''; if (!fid) return null;
      var els = document.querySelectorAll('[form="' + fid + '"][required]'), seen = {}, i, el, alt;
      for (i = 0; i < els.length; i++) {
        el = els[i];
        if (el.disabled || !el.closest('.dc-pz')) continue;
        if (el.type === 'radio') { if (seen[el.name]) continue; seen[el.name] = true; alt = document.querySelectorAll('[form="' + fid + '"][type="radio"]'); if (![].some.call(alt, function (r) { return r.name === el.name && r.checked; })) return el; }
        else if (el.type === 'checkbox') { if (!el.checked) return el; }
        else if (!String(el.value || '').trim()) return el;
      }
      return null;
    };
    var flag = function (el) {
      var box = el.closest('.dc-pz-chips') || el.closest('.dc-pz-field') || el.closest('.dc-pz') || el.parentNode;
      box.classList.remove('is-missing'); void box.offsetWidth; box.classList.add('is-missing');
      var msg = box.querySelector('[data-dc-req]');
      if (!msg) { msg = document.createElement('p'); msg.className = 'dc-pz-req'; msg.setAttribute('data-dc-req', ''); msg.setAttribute('role', 'alert'); box.appendChild(msg); }
      var lab = box.querySelector('.dc-pz-chips-l, label'), name = lab && lab.childNodes[0] ? String(lab.childNodes[0].textContent).trim() : '';
      // labels like "Choose your breed" are already a prompt
      msg.textContent = !name ? 'Choose an option' : /^(choose|select|pick)\b/i.test(name) ? name.charAt(0).toUpperCase() + name.slice(1) : 'Choose your ' + name.toLowerCase();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { el.focus({ preventScroll: true }); } catch (e) {}
    };
    document.addEventListener('change', function (e) { var box = e.target && e.target.closest && e.target.closest('.is-missing'); if (box && box.querySelector('[data-dc-req]')) { box.classList.remove('is-missing'); box.querySelector('[data-dc-req]').remove(); } }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target; if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var el = missing(form); if (!el) return;
      e.preventDefault(); e.stopImmediatePropagation(); flag(el);
    }, true);
    document.addEventListener('click', function (e) {
      var pb = e.target && e.target.closest && e.target.closest('.shopify-payment-button'); if (!pb) return;
      var form = pb.closest('form') || document.querySelector('form[data-type="add-to-cart-form"]'), el = missing(form); if (!el) return;
      e.preventDefault(); e.stopImmediatePropagation(); flag(el);
    }, true);
  }

  /* ---------- product page: gallery slides for Videos by design links ---------- */
  function mountXVid(v) {
    if (v._dcX) return; v._dcX = true;
    dcVidSrc(v.getAttribute('data-dc-vsrc'), function (r) {
      if (!r) return;
      if (v.hasAttribute('data-dc-vposter')) { v.preload = 'metadata'; v.src = (r.sd || r.hd) + '#t=1.5'; return; }
      v.setAttribute('data-src', r.hd); v.setAttribute('data-src-mobile', r.sd);
      dcVideo(v, v.closest('.product__media-item') || v.parentNode, false);
    });
  }
  // a shape picked on a combined listing: that shape's own video plays over the first gallery photo
  function gemVideo(list) {
    var old = document.querySelector('[data-dc-gemvid]'); if (old) old.remove();
    var slide = document.querySelector('.product__media-list .product__media-item'), media = slide && slide.querySelector('.product__media');
    if (!media || !list || !list.length) return;
    var v = document.createElement('video'); v.setAttribute('data-dc-gemvid', ''); v.className = 'dc-gemvid';
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    if (list[0].p) v.poster = list[0].p; v.src = pickSrc(list[0]);
    media.appendChild(v); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    var sw = document.querySelector('.product__media-list .js-media-list'); if (sw && sw.swiper && sw.swiper.slideTo) sw.swiper.slideTo(0);
  }

  /* ---------- product page: gemstone shape preview, breed sculpture link; breed page search ---------- */
  function mountGemField(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var val = root.querySelector('[data-dc-gem-value]'), img = root.querySelector('[data-dc-gem-img]'), cap = root.querySelector('[data-dc-gem-cap]'), tpl = root.getAttribute('data-dc-gem-shown') || '';
    root.addEventListener('change', function (e) {
      var r = e.target; if (!r || r.type !== 'radio') return;
      if (val) val.textContent = r.value;
      var u = r.getAttribute('data-img'), shown = r.getAttribute('data-shown') || r.value;
      if (img && u && img.getAttribute('src') !== u) { img.removeAttribute('srcset'); img.src = u; }
      if (img) img.alt = shown;
      if (cap) cap.textContent = shown !== r.value ? tpl.replace('[shape]', shown) : r.value;
      var want = r.value;
      vidList(r.getAttribute('data-vids'), r.getAttribute('data-vfiles'), function (list) { var on = root.querySelector('input[type="radio"]:checked'); if (on && on.value === want) gemVideo(list); });
    });
  }
  function mountBreedField(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var sel = root.querySelector('select'), a = root.querySelector('[data-dc-breed-link]'), fig = root.querySelector('[data-dc-breed-prev]');
    if (!sel) return;
    var page = String(root.getAttribute('data-dc-breed-page') || '').split('#')[0], label = root.getAttribute('data-dc-breed-label') || '', slug = DCB.handle;
    function update() {
      var b = sel.value, real = !!b && !/another/i.test(b);
      if (a && page) a.setAttribute('href', page + (real ? '#breed-' + slug(b) : ''));
      if (!fig) return;
      if (!real || !page || root.getAttribute('data-dc-breed-preview') !== 'true') { fig.hidden = true; return; }
      DCB.breedPhoto(page, b, function (src) {
        if (sel.value !== b) return;
        var im = fig.querySelector('img'), cp = fig.querySelector('figcaption');
        if (!src || !im) { fig.hidden = true; return; }
        im.src = src; im.alt = b; if (cp) cp.textContent = label.replace('[breed]', b);
        fig.hidden = false;
      });
    }
    sel.addEventListener('change', update);
    try {
      var wb = new URLSearchParams(window.location.search).get('breed');
      if (wb) { var hb = slug(wb); for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value && slug(sel.options[i].value) === hb) { sel.value = sel.options[i].value; break; } }
    } catch (e) {}
    if (sel.value) update();
  }
  function mountBreedGallery(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var input = root.querySelector('[data-bgal-search]'), cards = root.querySelectorAll('[data-dc-breed-card]'), empty = root.querySelector('[data-bgal-empty]');
    if (input) input.addEventListener('input', function () {
      var q = input.value.toLowerCase().trim(), n = 0, i, hit;
      for (i = 0; i < cards.length; i++) { hit = !q || (cards[i].getAttribute('data-name') || '').indexOf(q) > -1; cards[i].hidden = !hit; if (hit) n++; }
      if (empty) empty.hidden = n > 0;
    });
    var bar = root.querySelector('[data-bgal-bar]'), det = root.querySelector('[data-bgal-detail]');
    if (!bar || !det) return;
    var cells = bar.querySelectorAll('[data-bgal-pick]'); if (!cells.length) return;
    var one = function (sel) { return root.querySelector(sel); };
    var title = one('[data-bgal-title]'), note = one('[data-bgal-note]'), text = one('[data-bgal-text]'), idx = one('[data-bgal-index]'), por = one('[data-bgal-portrait]'), shop = one('[data-bgal-shop]'), wearH = one('[data-bgal-wearh]'), wearBtn = one('[data-bgal-wearbtn]');
    var current = null;
    function fill(el, name) { if (el && el.getAttribute('data-tpl')) el.textContent = el.getAttribute('data-tpl').split('[breed]').join(name); }
    function inView(cell) {
      if (cell.offsetLeft < bar.scrollLeft || cell.offsetLeft + cell.offsetWidth > bar.scrollLeft + bar.clientWidth) bar.scrollTo({ left: Math.max(0, cell.offsetLeft - bar.clientWidth / 2 + cell.offsetWidth / 2), behavior: 'smooth' });
    }
    function select(cell, keepHash) {
      if (!cell || cell === current) return;
      current = cell;
      var name = cell.getAttribute('data-title') || '', h = cell.getAttribute('data-bgal-pick'), i = [].indexOf.call(cells, cell), k;
      for (k = 0; k < cells.length; k++) cells[k].setAttribute('aria-pressed', cells[k] === cell ? 'true' : 'false');
      if (title) title.textContent = name;
      if (note) { note.textContent = cell.getAttribute('data-note') || ''; note.hidden = !note.textContent; }
      fill(text, name); fill(wearH, name); fill(wearBtn, name);
      if (idx) idx.textContent = (i + 1) + ' / ' + cells.length;
      if (por) {
        var big = cell.getAttribute('data-big'), img = por.querySelector('img');
        if (big && !img) { img = document.createElement('img'); img.alt = ''; por.insertBefore(img, por.firstChild); }
        por.style.setProperty('--fx', (cell.getAttribute('data-fx') || 50) + '%'); por.style.setProperty('--fy', (cell.getAttribute('data-fy') || 40) + '%'); por.style.setProperty('--z', cell.getAttribute('data-z') || 1.4);
        if (big && img) {
          por.classList.add('is-fading');
          var pre = new Image();
          pre.onload = pre.onerror = function () { if (current !== cell) return; img.removeAttribute('srcset'); img.src = big; img.alt = name; img.hidden = false; por.classList.remove('is-empty', 'is-fading'); };
          pre.src = big;
        } else { por.classList.add('is-empty'); por.classList.remove('is-fading'); if (img) { img.hidden = true; img.alt = ''; } }
      }
      if (shop) { var base = shop.getAttribute('data-base') || ''; shop.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'breed=' + h); }
      var quick = root.querySelectorAll('[data-dc-quick]');
      for (k = 0; k < quick.length; k++) quick[k].setAttribute('data-dc-quick-breed', name);
      if (!keepHash && window.history && history.replaceState) { try { history.replaceState(null, '', '#breed-' + h); } catch (er) {} }
      inView(cell);
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-bgal-pick],[data-bgal-step],[data-bgal-nav]') : null; if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-bgal-pick')) { select(t); return; }
      if (t.hasAttribute('data-bgal-nav')) { bar.scrollBy({ left: (+t.getAttribute('data-bgal-nav')) * bar.clientWidth * 0.8, behavior: 'smooth' }); return; }
      var vis = [].filter.call(cells, function (c) { return !c.hidden; }); if (!vis.length) return;
      var at = vis.indexOf(current), step = +t.getAttribute('data-bgal-step');
      select(vis[((at < 0 ? 0 : at) + step + vis.length) % vis.length]);
    });
    var hash = (window.location.hash || '').replace(/^#breed-/, '');
    var start = hash && bar.querySelector('[data-bgal-pick="' + hash.replace(/[^a-z0-9-]/g, '') + '"]');
    current = bar.querySelector('[data-bgal-pick][aria-pressed="true"]');
    if (start && start !== current) { current = null; select(start, true); setTimeout(function () { det.scrollIntoView({ block: 'start' }); window.scrollBy(0, -140); }, 60); }
    else if (current) inView(current);
  }


  /* ---------- breed sculptures drifting in the side margins (dc-breed-drift) ---------- */
  function mountDrift(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var id = root.getAttribute('data-drift-id'), old = document.querySelectorAll('body > [data-dc-drift]'), i;
    for (i = 0; i < old.length; i++) if (old[i] !== root && old[i].getAttribute('data-drift-id') === id && old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    if (root.parentNode !== document.body) document.body.appendChild(root); // a transformed ancestor would break position: fixed
    var items = root.querySelectorAll('.dc-drift-item'), n = items.length; if (!n) return;
    var mq = window.matchMedia ? window.matchMedia('(min-width: ' + (parseInt(root.getAttribute('data-min'), 10) || 1360) + 'px)') : null;
    var rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var tilt = parseFloat(root.getAttribute('data-tilt')) || 0, motion = root.getAttribute('data-motion') !== 'false';
    var op = 0.45, docH = 0, vh = 0, size = 200, avoid = [], on = false, ticking = false, rest = [];
    for (i = 0; i < n; i++) {
      items[i].classList.add(i % 2 ? 'is-right' : 'is-left');
      rest.push((i % 2 ? 1 : -1) * tilt * (0.6 + 0.4 * ((i * 3) % 4) / 3));
    }
    function measure() {
      docH = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
      vh = window.innerHeight; size = items[0].offsetWidth || 200;
      op = parseFloat(getComputedStyle(root).getPropertyValue('--drift-op')) || 0.45;
      avoid = [];
      var zones = document.querySelectorAll('.dc.dc-dark, .dc-lh-ann, .shopify-app-block, .dc-split, [data-dc-drift-avoid]'), sy = window.pageYOffset || 0, k, r;
      for (k = 0; k < zones.length; k++) { r = zones[k].getBoundingClientRect(); if (r.height) avoid.push([r.top + sy, r.bottom + sy]); }
    }
    function frame() {
      ticking = false;
      if (!on || !document.body.contains(root)) return;
      var sy = window.pageYOffset || 0, span = Math.max(1, docH - vh), still = !motion || (rm && rm.matches), speed = still ? 1 : 0.55, k, z;
      for (k = 0; k < n; k++) {
        var it = items[k], y = vh / 2 + (span * (k + 0.5) / n - sy) * speed - size / 2;
        if (y > vh + 60 || y < -size - 60) { it.style.visibility = 'hidden'; continue; }
        var p = Math.max(-1, Math.min(1, (y + size / 2 - vh / 2) / (vh / 2 + size / 2)));
        var top = sy + y, bottom = top + size, hide = false;
        for (z = 0; z < avoid.length; z++) if (bottom > avoid[z][0] + size * 0.25 && top < avoid[z][1] - size * 0.25) { hide = true; break; }
        var a = rest[k] + (still ? 0 : p * 6 * (k % 2 ? -1 : 1));
        it.style.visibility = 'visible';
        it.style.transform = 'translate3d(' + (k % 2 ? '24%' : '-24%') + ',' + y.toFixed(1) + 'px,0) rotate(' + a.toFixed(2) + 'deg)';
        it.style.opacity = hide ? '0' : (op * (1 - Math.abs(p) * 0.4)).toFixed(3);
      }
    }
    function req() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }
    function sync() {
      var want = !mq || mq.matches;
      if (want !== on) { on = want; root.classList.toggle('is-on', on); }
      if (on) { measure(); req(); }
    }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    if (mq && mq.addEventListener) mq.addEventListener('change', sync);
    if ('ResizeObserver' in window && document.body) new ResizeObserver(function () { if (on) { measure(); req(); } }).observe(document.body);
    document.addEventListener('shopify:section:unload', function (e) { if (e.detail && e.detail.sectionId === id && root.parentNode) { on = false; root.parentNode.removeChild(root); } });
    sync();
  }

  /* ---------- link fixes: old addresses point at working pages (Theme settings, DC · Link fixes) ---------- */
  var LINKFIX = null;
  function linkFixes() {
    if (LINKFIX) return LINKFIX; LINKFIX = {};
    var el = document.querySelector('script[data-dc-link-fixes]'), raw = '';
    if (el) { try { raw = JSON.parse(el.textContent) || ''; } catch (e) { raw = ''; } }
    String(raw).split(/\n/).forEach(function (line) { var p = line.split('='); if (p.length < 2) return; var from = p[0].trim().replace(/\/+$/, '').toLowerCase(), to = p.slice(1).join('=').trim(); if (from && to) LINKFIX[from] = to; });
    return LINKFIX;
  }
  function fixLinks(scope) {
    var map = linkFixes(), as, i, a, p; if (!Object.keys(map).length) return;
    as = (scope || document).querySelectorAll('a[href]');
    for (i = 0; i < as.length; i++) {
      a = as[i]; if (a.host && a.host !== window.location.host) continue;
      p = (a.pathname || '').replace(/\/+$/, '').toLowerCase();
      if (map[p]) a.setAttribute('href', map[p]);
    }
  }

  /* ---------- header bag: the count badge shows only when the bag has something in it ---------- */
  function cartCount() {
    var a = document.getElementById('cart-icon-bubble'); if (!a || a.dataset.dcCountWatch) return;
    a.dataset.dcCountWatch = '1';
    var sync = function () { var n = a.querySelector('.cart-count-bubble .visually-hidden') || a.querySelector('.cart-count-bubble'), c = n ? parseInt(n.textContent, 10) || 0 : 0; if (a.getAttribute('data-dc-count') !== String(c)) a.setAttribute('data-dc-count', c); };
    sync();
    if (window.MutationObserver) new MutationObserver(sync).observe(a, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- Instagram reels: a slowly drifting strip (drag, swipe, arrows), hover previews, a player with sound ---------- */
  function mountReels(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var vp = root.querySelector('[data-dc-reels-track]'), row = root.querySelector('[data-dc-reels-row]');
    if (!vp || !row || !row.children.length) return;
    var data = []; try { data = JSON.parse((root.querySelector('[data-dc-reels-data]') || {}).textContent || '[]') || []; } catch (e) { data = []; }
    var speed = parseFloat(root.getAttribute('data-speed')) || 28;
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var still = function () { return !!(mq && mq.matches); };
    var conn = navigator.connection || {}, save = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    var fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    var previews = root.getAttribute('data-hover') === 'true' && fine && !save;
    var now = function () { return window.performance && performance.now ? performance.now() : Date.now(); };
    var orig = [].slice.call(row.children);

    // copies for the endless loop: one set before the originals, enough after them to fill wide screens
    function addSet(before) {
      var frag = document.createDocumentFragment();
      orig.forEach(function (li) {
        var c = li.cloneNode(true), b = c.querySelector('button');
        c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block');
        if (b) b.setAttribute('tabindex', '-1');
        frag.appendChild(c);
      });
      if (before) row.insertBefore(frag, row.firstChild); else row.appendChild(frag);
    }
    addSet(true); addSet(false);
    // a reel whose cover file is missing shows as a plain card with its caption
    row.addEventListener('error', function (e) { var t = e.target; if (t && t.hasAttribute && t.hasAttribute('data-dc-reel-cover')) { var c = t.closest('.dc-reel-card'); if (c) c.classList.add('no-cover'); } }, true);
    var start = 0, setW = 0, pos = 0, lastSet = -1, raf = 0, last = 0, hold = 0, hover = false, focus = false, open = false, seen = false, drag = null, anim = null, eatClick = false;
    function measure() {
      var a = orig[0].offsetLeft, b = row.children[orig.length * 2], guard = 0;
      setW = b ? b.offsetLeft - a : 0;
      while (setW && row.scrollWidth - (a + setW) < vp.clientWidth + 4 && guard++ < 8) addSet(false);
      start = a;
    }
    function wrap() { if (!setW) return 0; var b = pos; if (pos >= start + setW) pos -= setW; else if (pos < start - setW * 0.5) pos += setW; return pos - b; }
    measure(); pos = start; vp.scrollLeft = pos; lastSet = vp.scrollLeft;
    root.classList.add('is-live');

    function frame(t) {
      raf = 0;
      if (!seen || document.hidden) { last = 0; return; }
      raf = requestAnimationFrame(frame);
      var dt = last ? Math.min(t - last, 64) : 0; last = t;
      if (!drag && Math.abs(vp.scrollLeft - lastSet) > 1) { pos = vp.scrollLeft; anim = null; hold = Math.max(hold, t + 1500); }
      if (anim) {
        var k = still() ? 1 : Math.min(1, (t - anim.t0) / anim.d);
        pos = anim.from + (anim.to - anim.from) * (1 - Math.pow(1 - k, 3));
        if (k >= 1) anim = null;
      } else if (!still() && !hover && !focus && !open && !drag && t > hold) pos += speed * dt / 1000;
      var sh = wrap(); if (anim && sh) { anim.from += sh; anim.to += sh; }
      if (Math.abs(vp.scrollLeft - pos) >= 0.5) vp.scrollLeft = pos;
      lastSet = vp.scrollLeft;
    }
    function run() { if (!raf && seen && !document.hidden) { last = 0; raf = requestAnimationFrame(frame); } }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; if (seen) run(); }, { rootMargin: '120px 0px' }).observe(vp);
    else { seen = true; run(); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) run(); });
    var rz = 0;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { var off = pos - start; measure(); pos = start + (setW ? ((off % setW) + setW) % setW : 0); vp.scrollLeft = pos; lastSet = vp.scrollLeft; }, 150); });

    // pauses: mouse over the strip, keyboard focus inside it, touch, trackpad
    vp.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    vp.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; hold = Math.max(hold, now() + 500); } });
    vp.addEventListener('touchstart', function () { hold = now() + 3000; }, { passive: true });
    vp.addEventListener('wheel', function () { hold = now() + 2000; }, { passive: true });
    root.addEventListener('focusin', function (e) { var t = e.target; focus = vp.contains(t) && !!(t.matches && (function () { try { return t.matches(':focus-visible'); } catch (x) { return true; } })()); });
    root.addEventListener('focusout', function (e) { if (!vp.contains(e.relatedTarget)) focus = false; });

    // mouse drag (touch scrolls natively)
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    vp.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; drag = { x: e.clientX, p: pos, id: e.pointerId, moved: false }; anim = null; });
    window.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) { if (Math.abs(dx) < 6) return; drag.moved = true; vp.classList.add('is-dragging'); stopPreview(); }
      pos = drag.p - dx; drag.p += wrap();
      vp.scrollLeft = pos; lastSet = vp.scrollLeft;
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      if (drag.moved) { eatClick = true; setTimeout(function () { eatClick = false; }, 0); }
      drag = null; vp.classList.remove('is-dragging'); hold = now() + 1200;
    }
    window.addEventListener('pointerup', endDrag); window.addEventListener('pointercancel', endDrag);

    // arrows: glide by a screenful less one card
    function glide(dir) {
      var c = orig[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0);
      var n = Math.max(1, Math.floor(vp.clientWidth / c) - 1);
      anim = { from: pos, to: pos + dir * c * n, t0: now(), d: 750 }; hold = now() + 4000; run();
    }
    var pv = root.querySelector('[data-dc-reels-prev]'), nx = root.querySelector('[data-dc-reels-next]');
    if (pv) pv.addEventListener('click', function () { glide(-1); });
    if (nx) nx.addEventListener('click', function () { glide(1); });

    // light copies: read every playlist once the strip is near the screen, so the player can start inside the tap
    var light = {};
    function lightFor(i, cb) {
      var d = data[i]; if (!d || !d.v) { cb(null); return; }
      if (light[i]) { cb(light[i]); return; }
      dcVidSrc(d.v, function (v) { light[i] = v || { hd: d.v, sd: d.v }; cb(light[i]); });
    }
    var warmed = false;
    function warm() { if (warmed) return; warmed = true; data.forEach(function (d, i) { lightFor(i, function () {}); }); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en, ob) { if (en[0].isIntersecting) { warm(); ob.disconnect(); } }, { rootMargin: '600px 0px' }).observe(vp);
    else warm();

    // hover preview: the card under the mouse plays its light copy, muted
    var cur = null;
    function stopPreview() { if (!cur) return; var v = cur.querySelector('.dc-reel-vid'); cur.classList.remove('is-previewing'); if (v) v.pause(); cur = null; }
    if (previews) {
      row.addEventListener('pointerover', function (e) {
        if (e.pointerType !== 'mouse' || drag) return;
        var card = e.target.closest && e.target.closest('.dc-reel-card'); if (!card || card === cur) return;
        stopPreview(); cur = card;
        var v = card.querySelector('.dc-reel-vid'); if (!v) return;
        v.onplaying = function () { if (cur === card) card.classList.add('is-previewing'); };
        lightFor(+card.getAttribute('data-dc-reel'), function (src) {
          if (cur !== card || !src) return;
          var u = src.sd || src.hd; if (v.getAttribute('src') !== u) v.src = u;
          v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {});
        });
      });
      row.addEventListener('pointerout', function (e) { if (cur && e.target.closest && e.target.closest('.dc-reel-card') === cur && !cur.contains(e.relatedTarget)) stopPreview(); });
    }

    // the player
    var dlg = root.querySelector('[data-dc-reels-dlg]');
    if (!dlg) return;
    var player = dlg.querySelector('[data-dc-reels-player]'), stage = dlg.querySelector('[data-dc-reels-stage]'), bar = dlg.querySelector('[data-dc-reels-bar]'), embed = dlg.querySelector('[data-dc-reels-embed]'), info = dlg.querySelector('.dc-reel-info');
    var capEl = dlg.querySelector('[data-dc-reels-cap]'), price = dlg.querySelector('[data-dc-reels-price]'), shop = dlg.querySelector('[data-dc-reels-shop]'), shopText = dlg.querySelector('[data-dc-reels-shoptext]'), ig = dlg.querySelector('[data-dc-reels-ig]'), sound = dlg.querySelector('[data-dc-reels-sound]');
    var shopLabel = root.getAttribute('data-shop') || 'Shop this piece', idx = 0, opener = null, muted = false;
    // the player lives on body so no section styling or transform can trap it; the theme editor reload removes it
    if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
    dlg.classList.add('dc', 'dc-dark');
    document.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.contains(root) && dlg.parentNode) { if (open) close(); dlg.parentNode.removeChild(dlg); } });
    function setSound() { stage.classList.toggle('is-muted', player.muted); sound.setAttribute('aria-pressed', player.muted ? 'false' : 'true'); sound.setAttribute('aria-label', player.muted ? 'Sound on' : 'Sound off'); }
    function playAt(i) {
      var src = light[i]; if (!src) return false;
      player.src = pickSrc(src); player.muted = muted; setSound();
      var p = player.play();
      if (p && p.catch) p.catch(function () { if (!player.muted && idx === i) { player.muted = true; setSound(); var q = player.play(); if (q && q.catch) q.catch(function () {}); } });
      return true;
    }
    function show(i) {
      idx = (i + data.length) % data.length;
      var d = data[idx] || {};
      capEl.textContent = d.c || '';
      price.hidden = !d.s; price.textContent = d.s ? (d.s.f ? 'From ' : '') + d.s.m : '';
      if (d.s) { shop.href = d.s.u; shopText.textContent = shopLabel; shop.hidden = false; }
      else if (d.b) { shop.href = d.b.u; shopText.textContent = d.b.t; shop.hidden = false; }
      else shop.hidden = true;
      ig.href = d.l || '#'; ig.hidden = !d.l;
      var isEmbed = !d.v && !!d.e;
      dlg.classList.toggle('is-embed', isEmbed); stage.classList.remove('is-paused');
      player.pause(); player.removeAttribute('src'); stage.style.removeProperty('--dc-r'); bar.style.width = '0';
      embed.innerHTML = ''; fitStage();
      if (isEmbed) {
        // Instagram's own player, framed so only the reel shows (its header and footer sit outside the frame)
        var f = document.createElement('iframe');
        f.src = d.e; f.title = 'Instagram reel' + (d.c ? ': ' + d.c : '');
        f.setAttribute('frameborder', '0'); f.setAttribute('scrolling', 'no'); f.setAttribute('allowtransparency', 'true');
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; clipboard-write');
        embed.appendChild(f);
        // the reel's own cover sits over the frame until the visitor taps into Instagram's player
        if (d.p) {
          var cv = document.createElement('span'); cv.className = 'dc-reel-cover'; cv.setAttribute('aria-hidden', 'true');
          cv.style.backgroundImage = 'url("' + String(d.p).replace(/"/g, '%22') + '")';
          cv.innerHTML = '<span class="dc-reel-play"><svg viewBox="0 0 24 24" focusable="false"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg></span>';
          embed.appendChild(cv);
        }
        fitStage();
        return;
      }
      if (d.p) player.poster = d.p; else player.removeAttribute('poster');
      var want = idx;
      if (!playAt(idx)) lightFor(idx, function () { if (open && idx === want) { muted = true; playAt(want); } });
    }
    // the reel frame is 9:16: as tall as the screen allows on desktop (under it sits the caption strip),
    // full width on phones. Instagram's embed is a 54px header, a 4:5 box holding the 9:16 video, then a
    // footer; at 0.8 times the frame height its video exactly fills the frame once shifted up and left.
    function fitStage() {
      var W = window.innerWidth, H = window.innerHeight, phone = W < 761, vw, vh, pass;
      // two passes: the caption strip's height depends on the frame's width
      for (pass = 0; pass < 2; pass++) {
        var ih = info ? info.offsetHeight : 170;
        if (phone) { vw = W; vh = vw * 16 / 9; if (vh > H - ih - 2) { vh = H - ih - 2; vw = vh * 9 / 16; } }
        else { vh = Math.min(H - 56 - ih, 760); vw = vh * 9 / 16; }
        vw = Math.floor(vw); vh = Math.floor(vw * 16 / 9);
        dlg.style.setProperty('--dc-vw', vw + 'px'); dlg.style.setProperty('--dc-vh', vh + 'px');
      }
      var f = embed.querySelector('iframe'); if (!f) return;
      // a hair wider than exact, so no line of Instagram's footer peeks under the video
      var fw = Math.ceil(vh * 0.8) + 2;
      f.style.width = fw + 'px'; f.style.height = (vh + 54 + 180) + 'px'; f.style.top = '-54px'; f.style.left = -Math.round((fw - vw) / 2) + 'px';
    }
    window.addEventListener('resize', function () { if (open) fitStage(); });
    // a tap into Instagram's player moves focus into its frame: that is when the cover steps aside
    window.addEventListener('blur', function () {
      setTimeout(function () {
        var a = document.activeElement;
        if (open && a && a.tagName === 'IFRAME' && embed.contains(a)) { var c = embed.querySelector('.dc-reel-cover'); if (c) c.classList.add('is-gone'); }
      }, 0);
    });
    function openAt(i, from) {
      var d = data[i]; if (!d) return;
      if (!d.v && !d.e) { if (d.l) window.open(d.l, '_blank', 'noopener'); return; }
      opener = from || null; open = true; stopPreview(); muted = false;
      document.documentElement.classList.add('dc-reel-lock');
      if (dlg.showModal) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } } else dlg.setAttribute('open', '');
      show(i);
    }
    function close() { if (dlg.close) dlg.close(); else { dlg.removeAttribute('open'); onClose(); } }
    function onClose() {
      open = false; hold = now() + 800;
      player.pause(); player.removeAttribute('src'); try { player.load(); } catch (e) {}
      embed.innerHTML = ''; dlg.classList.remove('is-embed');
      document.documentElement.classList.remove('dc-reel-lock');
      if (opener) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    }
    dlg.addEventListener('close', onClose);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.querySelector('[data-dc-reels-close]').addEventListener('click', close);
    [].forEach.call(dlg.querySelectorAll('[data-dc-reels-go]'), function (b) { b.addEventListener('click', function () { show(idx + (+b.getAttribute('data-dc-reels-go'))); }); });
    dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); } });
    sound.addEventListener('click', function () { player.muted = !player.muted; muted = player.muted; setSound(); if (player.paused) { var p = player.play(); if (p && p.catch) p.catch(function () {}); } });
    player.addEventListener('click', function () { if (player.paused) { var p = player.play(); if (p && p.catch) p.catch(function () {}); } else player.pause(); });
    player.addEventListener('play', function () { stage.classList.remove('is-paused'); });
    player.addEventListener('pause', function () { if (open && !dlg.classList.contains('is-embed') && player.getAttribute('src')) stage.classList.add('is-paused'); });
    player.addEventListener('loadedmetadata', function () { if (player.videoWidth && player.videoHeight) stage.style.setProperty('--dc-r', Math.max(0.5625, Math.min(1, player.videoWidth / player.videoHeight)).toFixed(4)); });
    player.addEventListener('timeupdate', function () { if (player.duration) bar.style.width = (player.currentTime / player.duration * 100).toFixed(2) + '%'; });
    var tx = null;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; tx = { x: t.clientX, y: t.clientY }; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tx) return; var t = e.changedTouches[0], dx = t.clientX - tx.x, dy = t.clientY - tx.y; tx = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) show(idx + (dx < 0 ? 1 : -1));
    });
    row.addEventListener('click', function (e) {
      if (eatClick) { e.preventDefault(); e.stopPropagation(); return; }
      var card = e.target.closest && e.target.closest('.dc-reel-card'); if (!card) return;
      openAt(+card.getAttribute('data-dc-reel'), card);
    });
  }

  /* ---------- product pages: the design switcher bar (cat / dog tabs, arrows, current design in view) ---------- */
  function mountProductNav(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var tabs = root.querySelectorAll('[data-dc-pnav-tab]'), lists = root.querySelectorAll('[data-dc-pnav-list]');
    var prev = root.querySelector('[data-dc-pnav-go="-1"]'), next = root.querySelector('[data-dc-pnav-go="1"]');
    function shown() { for (var i = 0; i < lists.length; i++) if (!lists[i].hidden) return lists[i]; return null; }
    function sync() {
      var l = shown(); if (!l || !prev || !next) return;
      var over = l.scrollWidth > l.clientWidth + 2;
      prev.hidden = next.hidden = !over;
      prev.disabled = l.scrollLeft < 4; next.disabled = l.scrollLeft > l.scrollWidth - l.clientWidth - 4;
    }
    function center(l) { var c = l && l.querySelector('[aria-current="page"]'); if (c) l.scrollLeft = Math.max(0, c.offsetLeft - (l.clientWidth - c.offsetWidth) / 2); }
    [].forEach.call(tabs, function (t) {
      t.addEventListener('click', function () {
        var k = t.getAttribute('data-dc-pnav-tab');
        [].forEach.call(tabs, function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        [].forEach.call(lists, function (l) { l.hidden = l.getAttribute('data-dc-pnav-list') !== k; });
        var l = shown(); if (l) { l.scrollLeft = 0; center(l); } sync();
      });
    });
    [prev, next].forEach(function (b, i) { if (b) b.addEventListener('click', function () { var l = shown(); if (l) l.scrollBy({ left: (i ? 1 : -1) * l.clientWidth * 0.7, behavior: 'smooth' }); }); });
    [].forEach.call(lists, function (l) { l.addEventListener('scroll', sync, { passive: true }); });
    window.addEventListener('resize', sync);
    center(shown()); sync();
  }

  /* ---------- product pages: Drop a hint (a note to Andrew, then the hint sent from her own phone or email) ---------- */
  function mountHint(root) {
    if (root.dataset.dcMounted) return; root.dataset.dcMounted = '1';
    var dlg = root.querySelector('[data-dc-hint-dlg]'), openBtn = root.querySelector('[data-dc-hint-open]');
    if (!dlg || !openBtn) return;
    var form = dlg.querySelector('form'), steps = dlg.querySelectorAll('[data-dc-hint-step]');
    var fid = root.getAttribute('data-form-id'), title = root.getAttribute('data-title') || '', base = root.getAttribute('data-url') || window.location.href.split('?')[0];
    var vmap = {}; try { vmap = JSON.parse((root.querySelector('[data-dc-hint-variants]') || {}).textContent || '{}') || {}; } catch (e) { vmap = {}; }
    var q = function (s) { return dlg.querySelector(s); };
    var link = base, msg = '';
    function step(n) { [].forEach.call(steps, function (s) { s.hidden = s.getAttribute('data-dc-hint-step') !== String(n); }); }
    function choices() {
      var out = [], pf = fid ? document.getElementById(fid) : null, idEl = pf && pf.querySelector('[name="id"]'), vid = idEl ? idEl.value : '';
      // option values, with sizes named ("Ring size 7" rather than a bare 7)
      var names = vmap._n || [], vo = vmap[vid];
      if (vo && vo.length && !(vo.length === 1 && vo[0] === 'Default Title')) out.push(vo.map(function (v, i) { return /size/i.test(names[i] || '') ? names[i] + ' ' + v : v; }).join(', '));
      if (fid) {
        var els = document.querySelectorAll('[form="' + fid + '"][name^="properties["]'), seen = {};
        [].forEach.call(els, function (el) {
          var key = el.name.slice(11, -1), val = '';
          if (el.type === 'radio') { if (!el.checked) return; val = el.value; }
          else if (el.tagName === 'SELECT' || el.type === 'text') val = el.value;
          else return;
          val = String(val || '').split(' (')[0].trim();
          if (!val || seen[key] || /^_/.test(key)) return; seen[key] = true;
          out.push(key + ': ' + val);
        });
      }
      return { text: out.join(' · '), vid: vid };
    }
    function close() { if (!dlg.open) return; if (dlg.close) dlg.close(); else { dlg.removeAttribute('open'); onClose(); } }
    function onClose() { document.documentElement.classList.remove('dc-hint-lock'); document.removeEventListener('keydown', onKey, true); try { openBtn.focus({ preventScroll: true }); } catch (e) {} }
    function onKey(e) { if (e.key === 'Escape' && dlg.open) { e.preventDefault(); close(); } }
    openBtn.addEventListener('click', function () {
      var c = choices();
      link = base + (c.vid ? '?variant=' + c.vid : '');
      q('[data-dc-hint-choices-text]').textContent = c.text;
      q('[data-dc-hint-choices]').value = c.text;
      q('[data-dc-hint-link]').value = link;
      step(1); built = false; q('[data-dc-hint-saved]').hidden = true;
      document.documentElement.classList.add('dc-hint-lock');
      document.addEventListener('keydown', onKey, true);
      if (dlg.showModal) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } } else dlg.setAttribute('open', '');
    });
    dlg.addEventListener('close', onClose);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    q('[data-dc-hint-close]').addEventListener('click', close);
    // the note for Andrew is a normal contact form post into a hidden frame: Shopify's bot check can run (it holds
    // the first submit and sends it again itself) and the page stays put; the frame's address says whether it saved
    var sink = root.querySelector('.dc-hint-sink'), built = false;
    if (sink) form.setAttribute('target', sink.name);
    if (sink) sink.addEventListener('load', function () {
      var u = ''; try { u = sink.contentWindow.location.href; } catch (x) { u = ''; }
      if (/contact_posted=true/.test(u)) q('[data-dc-hint-saved]').hidden = false;
      if (dlg.open) { try { q('[data-dc-hint-ready]').focus({ preventScroll: true }); } catch (x) {} }
    });
    form.addEventListener('submit', function (e) {
      if (!sink) e.preventDefault();
      if (built) return; built = true;
      var mine = q('[data-dc-hint-mine]').value.trim(), their = q('[data-dc-hint-their]').value.trim(), c = q('[data-dc-hint-choices]').value;
      msg = 'Hi ' + their + ', a little hint from ' + mine + '. This is the one I love: ' + title + (c ? ' (' + c + ')' : '') + '. ' + link;
      var enc = encodeURIComponent;
      q('[data-dc-hint-ready]').textContent = 'Now send it to ' + their;
      q('[data-dc-hint-msg]').textContent = msg;
      q('[data-dc-hint-sms]').href = 'sms:?&body=' + enc(msg);
      q('[data-dc-hint-wa]').href = 'https://wa.me/?text=' + enc(msg);
      q('[data-dc-hint-mail]').href = 'mailto:?subject=' + enc('A little hint from ' + mine) + '&body=' + enc(msg);
      var nat = q('[data-dc-hint-native]'); nat.hidden = !navigator.share;
      step(2); try { q('[data-dc-hint-ready]').focus({ preventScroll: true }); } catch (x) {}
    });
    q('[data-dc-hint-native]').addEventListener('click', function () {
      if (!navigator.share) return;
      navigator.share({ title: 'A little hint', text: msg.replace(link, '').trim(), url: link }).catch(function () {});
    });
    q('[data-dc-hint-copy]').addEventListener('click', function () {
      var b = this, done = function () { var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = t; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(msg).then(done, function () {});
      else { var ta = document.createElement('textarea'); ta.value = msg; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0'; dlg.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (er) {} dlg.removeChild(ta); }
    });
  }

  /* ---------- boot ---------- */
  function parse(json) { try { return JSON.parse(json); } catch (e) { return {}; } }
  function init(scope) {
    scope = scope || document;
    var i, els;
    mountReveal(scope);
    fixLinks(scope);
    cartCount();
    if (document.querySelector('form[data-type="add-to-cart-form"]')) productFormGuard();
    els = scope.querySelectorAll('video[data-dc-vsrc]');
    for (i = 0; i < els.length; i++) mountXVid(els[i]);
    els = scope.querySelectorAll('[data-dc-pp]');
    for (i = 0; i < els.length; i++) DCB.pills(els[i]);
    if (window.matchMedia && matchMedia('(min-width: 761px)').matches) { var od = (scope || document).querySelectorAll('details[data-dc-open-desktop]'); for (var oi = 0; oi < od.length; oi++) od[oi].open = true; }
    els = scope.querySelectorAll('[data-dc-sticky]');
    for (i = 0; i < els.length; i++) mountSticky(els[i]);
    els = scope.querySelectorAll('[data-dc-questionnaire]');
    for (i = 0; i < els.length; i++) mountQuestionnaire(els[i]);
    els = scope.querySelectorAll('[data-dc-viewer360]');
    for (i = 0; i < els.length; i++) mountViewer360(els[i]);
    els = scope.querySelectorAll('[data-dc-drawer]');
    for (i = 0; i < els.length; i++) mountDrawer(els[i]);
    DCB.bind();
    els = scope.querySelectorAll('[data-dc-builder]');
    for (i = 0; i < els.length; i++) DCB.mount(els[i]);
    els = scope.querySelectorAll('[data-dc-shopgrid]');
    for (i = 0; i < els.length; i++) mountShopGrid(els[i]);
    els = scope.querySelectorAll('[data-dc-drift]');
    for (i = 0; i < els.length; i++) mountDrift(els[i]);
    els = scope.querySelectorAll('[data-dc-gem-field]');
    for (i = 0; i < els.length; i++) mountGemField(els[i]);
    els = scope.querySelectorAll('[data-dc-breed-field]');
    for (i = 0; i < els.length; i++) mountBreedField(els[i]);
    els = scope.querySelectorAll('[data-dc-breed-gallery]');
    for (i = 0; i < els.length; i++) mountBreedGallery(els[i]);
    els = scope.querySelectorAll('[data-dc-video-wrap]');
    for (i = 0; i < els.length; i++) mountVideoWrap(els[i]);
    els = scope.querySelectorAll('[data-dc-reels]');
    for (i = 0; i < els.length; i++) mountReels(els[i]);
    els = scope.querySelectorAll('[data-dc-pnav]');
    for (i = 0; i < els.length; i++) mountProductNav(els[i]);
    els = scope.querySelectorAll('[data-dc-hint]');
    for (i = 0; i < els.length; i++) mountHint(els[i]);
    els = scope.querySelectorAll('[data-dc-finder]');
    for (i = 0; i < els.length; i++) mountFinder(els[i]);
    els = scope.querySelectorAll('[data-dc-swap]');
    for (i = 0; i < els.length; i++) mountSwap(els[i]);
    els = scope.querySelectorAll('[data-dc-scene]');
    for (i = 0; i < els.length; i++) { if (!els[i].dataset.dcMounted) { els[i].dataset.dcMounted = '1'; els[i].innerHTML = scene(parse(els[i].getAttribute('data-dc-scene'))); } }
    els = scope.querySelectorAll('[data-dc-animal]');
    for (i = 0; i < els.length; i++) { if (!els[i].dataset.dcMounted) { els[i].dataset.dcMounted = '1'; els[i].innerHTML = animalOnly(els[i].getAttribute('data-dc-animal'), els[i].getAttribute('data-dc-metal') || 'gold'); } }
    els = scope.querySelectorAll('[data-dc-stone]');
    for (i = 0; i < els.length; i++) { if (!els[i].dataset.dcMounted) { els[i].dataset.dcMounted = '1'; els[i].innerHTML = stoneOnly(els[i].getAttribute('data-dc-shape') || 'round', els[i].getAttribute('data-dc-stone')); } }
    els = scope.querySelectorAll('[data-dc-bone]');
    for (i = 0; i < els.length; i++) { if (!els[i].dataset.dcMounted) { els[i].dataset.dcMounted = '1'; els[i].innerHTML = bone(); } }
    els = scope.querySelectorAll('[data-dc-configurator]');
    for (i = 0; i < els.length; i++) mountConfigurator(els[i]);
    els = scope.querySelectorAll('canvas[data-dc-dust]');
    for (i = 0; i < els.length; i++) dust(els[i]);
  }
  window.DCAtelier = { scene: scene, animal: animalOnly, stone: stoneOnly, bone: bone, init: init, builder: DCB, STONES: STONES, SHAPES: SHAPES, METALS: METALS, ANIMALS: ANIMALS };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
